var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef, useState } from "react";
import TocStockHeader from "@frameworks/web/components/features/TOC/CommonTocComponent/TocHeader/TocStockHeader";
import CustomValidityData from "./CustomValidity/CustomValidity";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import DiffMandate from "./Mandate/DiffMandate";
import { EInvestmentType, firstInstallmentConstentEnum, MfStatus, validityRadio, EReedemType, OrderDetailsDisplay, MFStatusDisplay, MFError, HoldingClientVsSchemeOutcomes, ESourcePage, defaultMutualFundsFilter, EErrorCodes, HoldingError, } from "./MutualFundConstant";
import MutualFundTransaction from "./MutualFundTransaction";
import SelectScheme from "./SelectScheme/SelectScheme";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import PaymentMethod, { EPaymentType, } from "@frameworks/web/components/features/TOC/NFO/paymentMethod/PaymentMethod";
import DiffrentBankAccount from "@frameworks/web/components/features/TOC/NFO/paymentMethod/BankAccount/DiffrentBankAccount";
import CreateNewMandate, { EMandateFlow } from "./Mandate/CreateNewMandate";
import Loader from "@frameworks/web/components/generic/loader";
import { EHoldingType, } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import SingleHeadingText from "@frameworks/web/components/features/TOC/CommonTocComponent/TocHeader/SingleHeadingText";
import _ from "underscore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import PaymentUpi from "./CommonComp/PaymentUpi";
import PaymentStatus from "./CommonComp/PaymentStatus";
import * as URLConfig from "@frameworks/web/config/domain";
import IBNotePage from "./CommonComp/IbNotePage";
import ClosingComponent from "./CommonComp/ClosingComponent";
import { accountDetails } from "@mainDi/webDi";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/MutualFund/mutualfundtoc.scss";
import MFTocHeader from "./CommonComp/MFTocHeader";
import MandateViewDetails from "./Mandate/MandateViewDetails";
import basicProfileDi from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import SideBarClientDetails from "@frameworks/shared-library/components/OrderBookSideBar/SideBarClientDetails";
import SideTxnFooter from "./SideTxnFooter";
import OrderStatusScreen from "./CommonComp/OrderStatusScreen";
import RedeemParent from "./RedeemComp/RedeemParent";
import { roundUpToTwoDecimalPlaces } from "@domains/utils/numberMethods";
import { isEmpty, removeEmptyKeyValuesPairs } from "@domains/utils/validation";
import { EActionTypeForPause } from "@domains/features/TOCJourney/entities/MFPauseResumeEntity";
import TxnConfirmationScreen from "./RedeemComp/TxnConfirmationScreen";
import CancelOrder from "./Miscellaneous/CancelOrder";
import PauseOrder from "./Miscellaneous/PauseOrder";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { getValidatedInstallmentForSIPMandate } from "@domains/utils/MFCalculator";
import mutualFundDi from "@mainDi/features/mutualFund/servicelocator";
import { MFSchemesPlanTypes } from "@domains/features/Markets/MutualFunds/entities/MFCommon";
import ResumeOrder from "./Miscellaneous/ResumeOrder";
import SwitchAndSTPMain from "./SwitchTransferFund/SwitchAndSTPMain";
import { EOrderBookStatus } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import investmentServices from "@frameworks/shared-library/components/TransactionJourney/MutualFund/investmentService";
import { EMutualFundOrderTabs } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IMutualFundTransactionsCommonEntity";
var config = URLConfig.config;
export var EMutualFundFlow;
(function (EMutualFundFlow) {
    EMutualFundFlow["PURCHASE"] = "purchase";
    EMutualFundFlow["APIERROR"] = "apiError";
    EMutualFundFlow["SCHEME"] = "scheme";
    EMutualFundFlow["MANDATE"] = "mandate";
    EMutualFundFlow["NEWMANDATE"] = "newMandate";
    EMutualFundFlow["VALIDITY"] = "validity";
    EMutualFundFlow["CONFIRMATION"] = "confirmation";
    EMutualFundFlow["PAYMENT"] = "payment";
    EMutualFundFlow["BANKACCOUNT"] = "bankAccount";
    EMutualFundFlow["REDEEM"] = "redeem";
    EMutualFundFlow["LOADER"] = "loader";
    EMutualFundFlow["PAYEMENTSTATUS"] = "paymentStatus";
    EMutualFundFlow["IBREDIRECT"] = "IBRedirect";
    EMutualFundFlow["IBPAGENOTE"] = "IBPageNote";
    EMutualFundFlow["UPIAPPROVAL"] = "upiApproval";
    EMutualFundFlow["VALIDATEMANDATE"] = "validateMandate";
    EMutualFundFlow["VIEW_MANDATE_DETAIL"] = "viewMandate";
    EMutualFundFlow["ORDER_STATUS"] = "orderStatus";
    EMutualFundFlow["SWITCH"] = "Switch";
    EMutualFundFlow["CANCEL"] = "Cancel";
    EMutualFundFlow["PAUSE"] = "Pause";
    EMutualFundFlow["SWP"] = "SWP";
    EMutualFundFlow["CONFIRM_ORDER"] = "confirmOrder";
    EMutualFundFlow["STP"] = "STP";
    EMutualFundFlow["RESUME"] = "Resume";
    EMutualFundFlow["MODIFY"] = "Modify";
})(EMutualFundFlow || (EMutualFundFlow = {}));
export var urlMapper = {
    "261": 56,
};
export var getObjectFromInvestmentType = function (investmentType, mfData, frequency) {
    var _a, _b, _c, _d, _e, _f;
    switch (investmentType) {
        case EInvestmentType.SIP:
            return (_a = mfData === null || mfData === void 0 ? void 0 : mfData.sipData) === null || _a === void 0 ? void 0 : _a[frequency];
        case EInvestmentType.LUMPSUM:
            return (_b = mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumData) === null || _b === void 0 ? void 0 : _b[frequency];
        case EInvestmentType.STP:
        case EInvestmentType.SWITCH:
            return (_c = mfData === null || mfData === void 0 ? void 0 : mfData.stpData) === null || _c === void 0 ? void 0 : _c[frequency];
        case EInvestmentType.SWP:
            return (_d = mfData === null || mfData === void 0 ? void 0 : mfData.swpData) === null || _d === void 0 ? void 0 : _d[frequency];
        case EInvestmentType.REDEEM:
            return (_e = mfData === null || mfData === void 0 ? void 0 : mfData.redeemData) === null || _e === void 0 ? void 0 : _e[frequency];
        default:
            return (_f = mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumData) === null || _f === void 0 ? void 0 : _f[frequency];
    }
};
var MutualFund = function (props) {
    var _a, _b, _c, _d;
    var windowIB = null;
    var navigate = useNavigate();
    var location = useLocation();
    var locationState = location.state;
    var device = DeviceContext();
    var _e = useParams(), isinParam = _e.isin, schemeGroupCodeParams = _e.schemeGroupCode, schemeCodeParams = _e.schemeCode;
    var _f = __read(useState(), 2), purchaseFormData = _f[0], setPurchaseFormData = _f[1];
    var _g = __read(useState(props.isTriggeredFromOrderBook
        ? EMutualFundFlow.NEWMANDATE
        : props.isRetryPayment || (locationState === null || locationState === void 0 ? void 0 : locationState.isRetryPayment)
            ? EMutualFundFlow.PAYMENT
            : (locationState === null || locationState === void 0 ? void 0 : locationState.isRedeem) || props.isRedeem
                ? EMutualFundFlow.REDEEM
                : EMutualFundFlow.PURCHASE), 2), tocFlow = _g[0], setTOCFlow = _g[1];
    var _h = __read(useState(EMutualFundFlow.PURCHASE), 2), previousScreenState = _h[0], setPreviousScreenState = _h[1];
    var _j = __read(useState(EReedemType.DEMAT), 2), redeemType = _j[0], setRedeemType = _j[1];
    var _k = __read(useState(false), 2), redeemError = _k[0], setRedeemError = _k[1];
    var _l = __read(useState(), 2), parentMfData = _l[0], setParentMfdata = _l[1];
    var _m = __read(useState(), 2), allmfData = _m[0], setAllMFData = _m[1];
    var _o = __read(useState(), 2), mfData = _o[0], setMFData = _o[1];
    var _p = __read(useState(), 2), folioList = _p[0], setFolioList = _p[1];
    var _q = __read(useState(), 2), startDate = _q[0], setStartDate = _q[1];
    var _r = __read(useState(false), 2), MandateError = _r[0], setMandateError = _r[1];
    var _s = __read(useState(), 2), selectedMandate = _s[0], setSelectedMandate = _s[1];
    var _t = __read(useState(), 2), mandateList = _t[0], setMandateList = _t[1];
    var _u = __read(useState(), 2), bankList = _u[0], setBankList = _u[1];
    var _v = __read(useState(), 2), selectedBank = _v[0], setSelectedBank = _v[1];
    var _w = __read(useState((props === null || props === void 0 ? void 0 : props.investmentType) ||
        ((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.investmentType) ||
        EInvestmentType.SIP), 2), investmentType = _w[0], setInvestmentType = _w[1];
    var _x = __read(useState(), 2), folio = _x[0], setFolio = _x[1];
    var _y = __read(useState(), 2), selectedFolio = _y[0], setSelectedFolio = _y[1];
    var _z = __read(useState("".concat(props.schemeCode) || "".concat(schemeCodeParams)), 2), schemeCode = _z[0], setSchemeListKey = _z[1];
    var _0 = __read(useState("".concat(props.isin) || "".concat(isinParam)), 2), isin = _0[0], setISIN = _0[1];
    var _1 = __read(useState((props === null || props === void 0 ? void 0 : props.ifNfo) || ((_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.ifNfo)), 2), ifNfo = _1[0], setIfNfo = _1[1];
    var _2 = __read(useState((props === null || props === void 0 ? void 0 : props.schemeGroupCode) || schemeGroupCodeParams), 2), schemeGroupCode = _2[0], setSchemeGroupCode = _2[1];
    var _3 = __read(useState(), 2), orderData = _3[0], setOrderData = _3[1];
    var _4 = __read(useState(), 2), purchaseError = _4[0], setPurchaseError = _4[1];
    var _5 = __read(useState({
        upi: "",
        bankAcnt: "",
        bankCd: "",
        ifsc: "",
    }), 2), selectedUpi = _5[0], setSelectedUpi = _5[1];
    var _6 = __read(useState(), 2), paymentMethod = _6[0], setPaymentMethod = _6[1];
    var _7 = __read(useState(), 2), paymentstatusDetails = _7[0], setPaymentstatusDetails = _7[1];
    var _8 = __read(useState(), 2), mfHoldingData = _8[0], setMFHoldingData = _8[1];
    var paymentRef = useRef(null);
    var schemeCodeRef = useRef("".concat(props.schemeCode) || "".concat(schemeCodeParams));
    var investmentTypeRef = useRef(null);
    var _9 = __read(useState({
        isRedeem: (locationState === null || locationState === void 0 ? void 0 : locationState.isRedeem) || (props === null || props === void 0 ? void 0 : props.isRedeem) || false,
        isRetryPayment: (locationState === null || locationState === void 0 ? void 0 : locationState.isRetryPayment) || (props === null || props === void 0 ? void 0 : props.isRetryPayment) || false,
        isModify: (locationState === null || locationState === void 0 ? void 0 : locationState.isModify) || (props === null || props === void 0 ? void 0 : props.isModify) || false,
        modifyData: (locationState === null || locationState === void 0 ? void 0 : locationState.mfmodifyData) ||
            (props === null || props === void 0 ? void 0 : props.mfmodifyData) ||
            {},
    }), 2), externalData = _9[0], setExternalData = _9[1];
    var _10 = __read(useState(""), 2), serverError = _10[0], setServerError = _10[1];
    var _11 = __read(useState([]), 2), linkedSipData = _11[0], setLinkedSipData = _11[1];
    var _12 = __read(useState(false), 2), isViewDetailsMode = _12[0], setIsViewDetailsMode = _12[1];
    var _13 = __read(useState(""), 2), selectedMandateId = _13[0], setSelectedMandateId = _13[1];
    var temporaryViewMandateDetailsMandateId = useRef(null);
    var _14 = __read(useState(EHoldingType[(_c = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _c === void 0 ? void 0 : _c.investmentType] || EHoldingType.Demat), 2), physicalFlg = _14[0], setPhysicalFlg = _14[1];
    var _15 = __read(useState(), 2), orderStatus = _15[0], setOrderStatus = _15[1];
    var _16 = __read(useState(), 2), mfHoldingDetail = _16[0], setMfHoldingDetail = _16[1];
    // states related to switch fund
    var _17 = __read(useState(0), 2), amountSelectedForSwitch = _17[0], setAmountSelectedForSwitch = _17[1];
    var _18 = __read(useState(false), 2), isLongTermOnly = _18[0], setIsLongTermOnly = _18[1];
    var _19 = __read(useState([]), 2), switchTransferFundOptions = _19[0], setSwitchTransferFundOptions = _19[1];
    var _20 = __read(useState(false), 2), switchTransferFundsLoader = _20[0], setSwitchTransferFundsLoader = _20[1];
    var _21 = __read(useState(false), 2), switchTransferFundsError = _21[0], setSwitchTransferFundsError = _21[1];
    var _22 = __read(useState(false), 2), switchTransferFundsFilterLoader = _22[0], setSwitchTransferFundsFilterLoader = _22[1];
    var _23 = __read(useState(), 2), switchtoSchemeValidationDetails = _23[0], setSwitchtoSchemeValidationDetails = _23[1];
    var _24 = __read(useState(false), 2), toSchemeDetailsLoader = _24[0], setToSchemeDetailsLoader = _24[1];
    var _25 = __read(useState(defaultMutualFundsFilter), 2), switchTransferFundsFilters = _25[0], setSwitchTransferFundsFilters = _25[1];
    var _26 = __read(useState(false), 2), isFundSelectedForSwitchTransfer = _26[0], setIsFundSelectedForSwitchTransfer = _26[1];
    var _27 = __read(useState(null), 2), selectedToScheme = _27[0], setSelectedToScheme = _27[1];
    // this state is to check mandate flow in create new mandate section
    var _28 = __read(useState(null), 2), mandateFlow = _28[0], setMandateFlow = _28[1];
    // states related to stp fund
    var _29 = __read(useState({
        amount: { msg: "", status: false },
        installmentCount: { msg: "", status: false },
        mandateId: { msg: "", status: false },
    }), 2), formErrors = _29[0], setFormErrors = _29[1];
    var _30 = __read(useState(!(props === null || props === void 0 ? void 0 : props.isModify)), 2), showScheme = _30[0], setShowScheme = _30[1];
    var _31 = __read(useState(false), 2), isCalendarOpen = _31[0], setIsCalendarOpen = _31[1];
    var currentfirstInstallmentValueRef = useRef("");
    var _32 = __read(useState(), 2), productCategoryData = _32[0], setProductCategoryData = _32[1];
    var _33 = __read(useState(), 2), schemeType = _33[0], setSchemeType = _33[1];
    var availableHoldings = useMemo(function () {
        var _a, _b;
        if (((_a = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _a === void 0 ? void 0 : _a.dpFlag) && (mfData === null || mfData === void 0 ? void 0 : mfData.transactionMode)) {
            var key = "".concat(props.clientDetails.dpFlag, "_").concat(mfData.transactionMode);
            return ((_b = HoldingClientVsSchemeOutcomes[key]) === null || _b === void 0 ? void 0 : _b.split("")) || [];
        }
        else
            return [];
    }, [(_d = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _d === void 0 ? void 0 : _d.dpFlag, mfData === null || mfData === void 0 ? void 0 : mfData.transactionMode]);
    var purchaseApplyBtnDisabled = useMemo(function () {
        if (isCalendarOpen) {
            return true;
        }
        if (investmentType === EInvestmentType.SIP) {
            if (!(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment) ||
                !(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency) ||
                !(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate) ||
                !selectedMandate) {
                return true;
            }
        }
        if (investmentType === EInvestmentType.LUMPSUM) {
            return !Boolean(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount) || formErrors.amount.status;
        }
        return !Object.values(formErrors).every(function (z) { return z.status === false; });
    }, [
        purchaseFormData,
        selectedMandate,
        formErrors,
        investmentType,
        isCalendarOpen,
    ]);
    var hendleScreenState = function (ss) {
        setPreviousScreenState(tocFlow);
        setTOCFlow(ss);
    };
    var getCategoryListings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dataFromAPI, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutualFundDi.mutualFunds.getMFCategoryFilters()];
                case 1:
                    dataFromAPI = _a.sent();
                    setProductCategoryData(dataFromAPI);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var changeScheme = function (SCode) {
        var _a, _b, _c, _d;
        var transactionType = investmentType; // maintaining local var for updated investment State value
        setSchemeListKey(SCode);
        schemeCodeRef.current = SCode;
        if (allmfData) {
            var selected_1 = allmfData.returnTypeList.find(function (x) { return x.schemeListKey === SCode; });
            if (selected_1) {
                setMFData(selected_1);
                if (investmentType !== EInvestmentType.REDEEM &&
                    props.clientDetails.direct_plan_enabled_flg !== "Y" &&
                    schemeType == MFSchemesPlanTypes.DIRECT) {
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, MFError.directNotAllowed), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
                else if (!Boolean((_a = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _a === void 0 ? void 0 : _a.dpFlag) ||
                    (props.clientDetails.dpFlag === EHoldingType.Physical &&
                        (selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.transactionMode) === EHoldingType.Demat) ||
                    (props.clientDetails.dpFlag === EHoldingType.Demat &&
                        (selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.transactionMode) === EHoldingType.Physical)) {
                    var screenDetails = ((_b = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _b === void 0 ? void 0 : _b.dpFlag)
                        ? ((_c = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _c === void 0 ? void 0 : _c.dpFlag) === EHoldingType.Physical
                            ? MFError.dematNotAllowed
                            : MFError.physicalNotAllowed
                        : MFError.noHoldingsType;
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, screenDetails), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
                else if ((transactionType === EInvestmentType.LUMPSUM ||
                    transactionType === EInvestmentType.SIP) &&
                    !(selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.lumpsumData) &&
                    !(selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.sipData)) {
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
                else {
                    hendleScreenState(EMutualFundFlow.PURCHASE);
                    setOrderStatus(undefined);
                }
                if ((selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.lumpsumFlag) && !(selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.sipFlag)) {
                    transactionType = EInvestmentType.LUMPSUM;
                    setInvestmentType(EInvestmentType.LUMPSUM);
                }
                else {
                    transactionType = EInvestmentType.SIP;
                    setInvestmentType(EInvestmentType.SIP);
                    getMfMandate();
                }
                if ((selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.transactionMode) === EHoldingType.Physical ||
                    props.clientDetails.dpFlag === EHoldingType.Physical) {
                    setPhysicalFlg(EHoldingType.Physical);
                }
                setPurchaseFormData(function (fData) {
                    var _a;
                    return __assign(__assign({}, fData), { sipFrequency: (_a = selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.sipFrequency[0]) === null || _a === void 0 ? void 0 : _a.value });
                });
                if (selected_1.sipFlag) {
                    transactionType = EInvestmentType.SIP;
                    setInvestmentType(EInvestmentType.SIP);
                    getMfMandate();
                }
                if (selected_1 &&
                    transactionType !== EInvestmentType.LUMPSUM &&
                    (selected_1.sipFlag || selected_1.swpFlag || selected_1.stpFlag)) {
                    // 1.if minGap greater than 0 then Now should be disable
                    //2. if maxgap is equal to 0 then diable Later
                    getSipStartDateData((_d = selected_1 === null || selected_1 === void 0 ? void 0 : selected_1.sipFrequency[0]) === null || _d === void 0 ? void 0 : _d.value, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, selected_1, transactionType);
                }
            }
        }
    };
    function getMfSwitchDetailFunds(request, isFirstCallOnPageLoad) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var cleanedFilterObj;
            return __generator(this, function (_b) {
                setSwitchTransferFundsLoader(true);
                cleanedFilterObj = removeEmptyKeyValuesPairs(request);
                cleanedFilterObj = __assign(__assign({}, cleanedFilterObj), (((_a = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _a === void 0 ? void 0 : _a.direct_plan_enabled_flg) !== "Y" && {
                    schPlan: ["Regular"],
                }));
                tocDi.tocJourney
                    .getMFSwitchDetails(cleanedFilterObj)
                    .then(function (data) {
                    var _a;
                    if (((_a = data === null || data === void 0 ? void 0 : data.mfSwitchDetails) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        setSwitchTransferFundOptions(data.mfSwitchDetails);
                        setSwitchTransferFundsError(false);
                        // Call filter details API only if we have funds to switch
                        if (isFirstCallOnPageLoad) {
                            getMFSwitchDetailsFilters();
                        }
                    }
                    else {
                        setSwitchTransferFundOptions([]);
                        setSwitchTransferFundsError(false);
                    }
                })
                    .catch(function (err) {
                    setSwitchTransferFundOptions([]);
                    setSwitchTransferFundsError(true);
                })
                    .finally(function () {
                    setSwitchTransferFundsLoader(false);
                });
                return [2 /*return*/];
            });
        });
    }
    var getMFSwitchDetailsFilters = function () {
        var _a;
        setSwitchTransferFundsFilterLoader(true);
        tocDi.tocJourney
            .getMFSwitchDetailsFilter(__assign({ isin: isin, txnType: investmentType }, (((_a = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _a === void 0 ? void 0 : _a.direct_plan_enabled_flg) !== "Y" && {
            schPlan: ["Regular"],
        })), ["amcName"])
            .then(function (data) {
            if (isEmpty(data))
                return;
            setSwitchTransferFundsFilters(data);
        })
            .catch(function () {
            // No results found screen will be show as filters will be set empty
        })
            .finally(function () {
            setSwitchTransferFundsFilterLoader(false);
        });
    };
    var getMFSwitchToSchemeDetails = function (selectedIsin, groupCode) {
        setToSchemeDetailsLoader(true);
        var request = {
            isin: selectedIsin,
            trxType: investmentType === EInvestmentType.SWITCH
                ? EInvestmentType.LUMPSUM
                : investmentType,
            clientCode: props.clientDetails.clientCode,
            isDirect: true,
            groupCode: groupCode,
            type: investmentType === EInvestmentType.REDEEM ? "R" : "P",
        };
        tocDi.tocJourney
            .getMFPurchase(request)
            .then(function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (data) {
                var transactionType = (_b = (_a = data === null || data === void 0 ? void 0 : data.schemePlanList[0]) === null || _a === void 0 ? void 0 : _a.returnTypeList[0]) === null || _b === void 0 ? void 0 : _b.transactionMode;
                var stpResData = investmentType === EInvestmentType.SWITCH
                    ? (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.schemePlanList[0]) === null || _c === void 0 ? void 0 : _c.returnTypeList[0]) === null || _d === void 0 ? void 0 : _d.lumpsumData) === null || _e === void 0 ? void 0 : _e["MONTHLY"]
                    : (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.schemePlanList[0]) === null || _f === void 0 ? void 0 : _f.returnTypeList[0]) === null || _g === void 0 ? void 0 : _g.stpData) === null || _h === void 0 ? void 0 : _h["MONTHLY"];
                if (investmentType === EInvestmentType.SWITCH &&
                    ((stpResData === null || stpResData === void 0 ? void 0 : stpResData.lumpsumFlag) !== "Y" ||
                        (transactionType !== (mfData === null || mfData === void 0 ? void 0 : mfData.transactionMode) &&
                            transactionType !== EHoldingType.DematPhysical &&
                            (mfData === null || mfData === void 0 ? void 0 : mfData.transactionMode) !== EHoldingType.DematPhysical))) {
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, ((stpResData === null || stpResData === void 0 ? void 0 : stpResData.lumpsumFlag) !== "Y"
                        ? MFError.switchNotAllowed
                        : HoldingError[EInvestmentType.SWITCH])), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
                else if (investmentType === EInvestmentType.STP &&
                    (transactionType === "D" || (stpResData === null || stpResData === void 0 ? void 0 : stpResData.stpFlag) !== "Y")) {
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, HoldingError[EInvestmentType.STP]), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
                else {
                    var toSchemeData = stpResData; // TO DO - Check if this data is being pulled correct
                    setSwitchtoSchemeValidationDetails(__assign(__assign({}, toSchemeData), { nav: (_k = (_j = data === null || data === void 0 ? void 0 : data.schemePlanList[0]) === null || _j === void 0 ? void 0 : _j.returnTypeList[0]) === null || _k === void 0 ? void 0 : _k.nav }));
                }
            }
            else {
                hendleScreenState(EMutualFundFlow.APIERROR);
                setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
            }
        })
            .catch(function () {
            setOrderStatus(__assign(__assign({}, MFError.Error), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
            hendleScreenState(EMutualFundFlow.ORDER_STATUS);
        })
            .finally(function () {
            setToSchemeDetailsLoader(false);
        });
    };
    var getHoldingDetail = function (transactionMode, txnType) {
        tocDi.tocJourney
            .getMFHoldingDetail({
            //to be from config
            clientCode: props.clientDetails.clientCode,
            isin: isin,
            // holdingType: "P",
        })
            // )
            .then(function (data) {
            var _a, _b, _c, _d, _e, _f;
            // If Client is not allowed to sell MF due to missing POA/DDPI
            if (Boolean((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.remarks)) {
                hendleScreenState(EMutualFundFlow.APIERROR);
                setOrderStatus(__assign(__assign({}, MFError.txnTypeNotAllowed(investmentType)), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined, description: (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.remarks }));
                return;
            }
            if (!!data && ((_d = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.clientHoldingDetails) === null || _d === void 0 ? void 0 : _d[0])) {
                var clientHoldingDetails = getValidHoldingDetailsByInvestmentType((_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.clientHoldingDetails, transactionMode);
                data.data.clientHoldingDetails = clientHoldingDetails;
                // If order is allowed on available folios
                if (clientHoldingDetails.length > 0) {
                    setMfHoldingDetail(data === null || data === void 0 ? void 0 : data.data);
                    setSelectedFolio(clientHoldingDetails[0]);
                    setPhysicalFlg(((_f = clientHoldingDetails[0]) === null || _f === void 0 ? void 0 : _f.folioType) === EReedemType.PHYSICAL
                        ? EHoldingType.Physical
                        : EHoldingType.Demat);
                }
                else {
                    // If order is not allowed on any of the available folios
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, (HoldingError[investmentType]
                        ? HoldingError[investmentType]
                        : MFError.noHoldingsType)), { genericDetails: undefined, genericDetailsCollapse: undefined, children: null }));
                }
            }
            else {
                // If order is not allowed on any of the available folios
                hendleScreenState(EMutualFundFlow.APIERROR);
                setOrderStatus(__assign(__assign({}, (HoldingError[investmentType]
                    ? HoldingError[investmentType]
                    : MFError.noHoldingsType)), { genericDetails: undefined, genericDetailsCollapse: undefined, children: null }));
            }
        });
    };
    var getValidHoldingDetailsByInvestmentType = function (data, transactionMode) {
        switch (investmentType) {
            case EInvestmentType.REDEEM:
            case EInvestmentType.SWP: {
                return data === null || data === void 0 ? void 0 : data.filter(function (item) {
                    var redeemAllowed = item.redeemAllowed === "t";
                    var matchesTransactionMode = transactionMode === EHoldingType.DematPhysical ||
                        (transactionMode === EHoldingType.Demat &&
                            item.folioType === EReedemType.DEMAT) ||
                        (transactionMode === EHoldingType.Physical &&
                            item.folioType === EReedemType.PHYSICAL);
                    return redeemAllowed && matchesTransactionMode;
                });
            }
            case EInvestmentType.STP: {
                var availableFolioForSwitch = data === null || data === void 0 ? void 0 : data.filter(function (item) {
                    return item.folioType === EReedemType.PHYSICAL &&
                        (transactionMode === EHoldingType.Physical ||
                            transactionMode === EHoldingType.DematPhysical);
                });
                if (availableFolioForSwitch.length > 0) {
                    var initialPayload = {
                        txnType: investmentType,
                        isin: isin,
                    };
                    getMfSwitchDetailFunds(initialPayload, true);
                    // getMFSwitchDetailsFilters();
                }
                return availableFolioForSwitch;
            }
            case EInvestmentType.SWITCH: {
                var availableFolioForSwitch = data === null || data === void 0 ? void 0 : data.filter(function (item) {
                    var matchesTransactionMode = transactionMode === EHoldingType.DematPhysical ||
                        (transactionMode === EHoldingType.Demat &&
                            item.folioType === EReedemType.DEMAT) ||
                        (transactionMode === EHoldingType.Physical &&
                            item.folioType === EReedemType.PHYSICAL);
                    return matchesTransactionMode;
                });
                if (availableFolioForSwitch.length > 0) {
                    var initialPayload = {
                        txnType: investmentType,
                        isin: isin,
                    };
                    getMfSwitchDetailFunds(initialPayload, true);
                    // getMFSwitchDetailsFilters();
                }
                return availableFolioForSwitch;
            }
            default:
                return data;
        }
    };
    var getInvType = function (mfdata) {
        var _a, _b, _c;
        if (mfdata === void 0) { mfdata = mfData; }
        if (!Boolean((_a = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _a === void 0 ? void 0 : _a.dpFlag) ||
            (props.clientDetails.dpFlag === EHoldingType.Physical &&
                (mfdata === null || mfdata === void 0 ? void 0 : mfdata.transactionMode) === EHoldingType.Demat) ||
            (props.clientDetails.dpFlag === EHoldingType.Demat &&
                (mfdata === null || mfdata === void 0 ? void 0 : mfdata.transactionMode) === EHoldingType.Physical)) {
            var screenDetails = ((_b = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _b === void 0 ? void 0 : _b.dpFlag)
                ? ((_c = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _c === void 0 ? void 0 : _c.dpFlag) === EHoldingType.Physical
                    ? MFError.dematNotAllowed
                    : MFError.physicalNotAllowed
                : MFError.noHoldingsType;
            hendleScreenState(EMutualFundFlow.APIERROR);
            setOrderStatus(__assign(__assign({}, screenDetails), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
        }
        else if ((investmentType === EInvestmentType.LUMPSUM ||
            investmentType === EInvestmentType.SIP) &&
            !(mfdata === null || mfdata === void 0 ? void 0 : mfdata.lumpsumData) &&
            !(mfdata === null || mfdata === void 0 ? void 0 : mfdata.sipData)) {
            hendleScreenState(EMutualFundFlow.APIERROR);
            setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
        }
        else {
            hendleScreenState(EMutualFundFlow.PURCHASE);
            if ((mfdata === null || mfdata === void 0 ? void 0 : mfdata.lumpsumFlag) && !(mfdata === null || mfdata === void 0 ? void 0 : mfdata.sipFlag)) {
                setInvestmentType(EInvestmentType.LUMPSUM);
                return EInvestmentType.LUMPSUM;
            }
            else if (investmentType === EInvestmentType.LUMPSUM &&
                !(mfdata === null || mfdata === void 0 ? void 0 : mfdata.lumpsumData) &&
                (mfdata === null || mfdata === void 0 ? void 0 : mfdata.sipData)) {
                setInvestmentType(EInvestmentType.SIP);
                return EInvestmentType.SIP;
            }
            else {
                if (investmentType) {
                    setInvestmentType(investmentType);
                    if (investmentType === EInvestmentType.SIP) {
                        getMfMandate();
                    }
                    return investmentType;
                }
                else {
                    setInvestmentType(EInvestmentType.SIP);
                    getMfMandate();
                    return EInvestmentType.SIP;
                }
            }
        }
    };
    var handleInitScreenState = function (investType, mfdata, transactionMode) {
        if (mfdata === void 0) { mfdata = mfData; }
        switch (investType) {
            case EInvestmentType.LUMPSUM:
                return getInvType(mfdata);
            case EInvestmentType.SIP:
                return getInvType(mfdata);
            case EInvestmentType.STP:
            case EInvestmentType.SWITCH: {
                if (mfdata.stpFlag && mfdata.stpData && mfdata.stpData["MONTHLY"]) {
                    setInvestmentType(investType);
                    getHoldingDetail(transactionMode, EMutualFundFlow.STP);
                    investType === EInvestmentType.STP &&
                        getSipStartDateData("MONTHLY", purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, mfdata);
                    hendleScreenState(EMutualFundFlow.STP);
                }
                else {
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, (investType === EInvestmentType.STP
                        ? MFError.stpNotAllowed
                        : MFError.switchNotAllowed)), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
                return;
            }
            // TO DO: Keeping it here for atleast the next 2 build.
            // case EInvestmentType.SWITCH:
            //   getHoldingDetail(transactionMode, EMutualFundFlow.SWITCH);
            //   setPurchaseFormData((fData) => {
            //     return {
            //       ...fData,
            //       sipFrequency: "MONTHLY",
            //     };
            //   });
            //   hendleScreenState(EMutualFundFlow.SWITCH);
            //   break;
            case EInvestmentType.CANCEL:
                hendleScreenState(EMutualFundFlow.CANCEL);
                break;
            case EInvestmentType.PAUSE:
                hendleScreenState(EMutualFundFlow.PAUSE);
                break;
            case EInvestmentType.RESUME:
                hendleScreenState(EMutualFundFlow.RESUME);
                break;
            case EInvestmentType.SWP:
                getHoldingDetail(transactionMode, EMutualFundFlow.SWP);
                getSipStartDateData("MONTHLY", purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, mfdata);
                hendleScreenState(EMutualFundFlow.SWP);
                break;
            case EInvestmentType.REDEEM:
                getHoldingDetail(transactionMode, EMutualFundFlow.REDEEM);
                hendleScreenState(EMutualFundFlow.REDEEM);
                break;
            default:
                // handle lumpsum && SIP condition
                return getInvType(mfdata);
        }
    };
    var setMfSelectedData = function (selectedData, type) {
        var _a, _b, _c;
        // if (props.clientDetails.dpFlag === EHoldingType.Physical) {
        //   selectedData.transactionMode = EHoldingType.Physical;
        // }
        setMFData(selectedData);
        if (!props.isModify) {
            // to set values from order and avoid set default values
            if ((selectedData === null || selectedData === void 0 ? void 0 : selectedData.transactionMode) ==
                EHoldingType.Physical ||
                props.clientDetails.dpFlag === EHoldingType.Physical) {
                setPhysicalFlg(EHoldingType.Physical);
            }
            setPurchaseFormData(function (fData) {
                var _a;
                return __assign(__assign({}, fData), { sipFrequency: (_a = selectedData === null || selectedData === void 0 ? void 0 : selectedData.sipFrequency[0]) === null || _a === void 0 ? void 0 : _a.value });
            });
        }
        if (investmentType !== EInvestmentType.REDEEM &&
            props.clientDetails.direct_plan_enabled_flg !== "Y" &&
            type == MFSchemesPlanTypes.DIRECT) {
            hendleScreenState(EMutualFundFlow.APIERROR);
            setOrderStatus(__assign(__assign({}, MFError.directNotAllowed), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
        }
        else {
            var investmentType_1 = handleInitScreenState(props.investmentType, selectedData, selectedData === null || selectedData === void 0 ? void 0 : selectedData.transactionMode);
            if (selectedData &&
                (selectedData === null || selectedData === void 0 ? void 0 : selectedData.sipFlag) &&
                investmentType_1 === EInvestmentType.SIP) {
                //2. if maxgap is equal to 0 then diable Later
                var firstInstallment = firstInstallmentConstentEnum.NOW;
                //default I have already setup Later
                // 1.if minGap greater than 0 then Now should be disable ---  remove from validation
                if (((_a = selectedData.sipData) === null || _a === void 0 ? void 0 : _a[(_b = selectedData === null || selectedData === void 0 ? void 0 : selectedData.sipFrequency[0]) === null || _b === void 0 ? void 0 : _b.value].minGapInDay) > 0) {
                    firstInstallment = firstInstallmentConstentEnum.LATER;
                }
                // if (
                //   selectedData.sipData?.[selectedData?.sipFrequency[0]?.value]
                //     .maxGapInDay === 0
                // ) {
                //   firstInstallment = firstInstallmentConstentEnum.NOW;
                // }
                getSipStartDateData((_c = selectedData === null || selectedData === void 0 ? void 0 : selectedData.sipFrequency[0]) === null || _c === void 0 ? void 0 : _c.value, firstInstallment, selectedData, investmentType_1);
            }
            // pull this functionality on a different function to check for all the possible trx types
            if (!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.sipFlag) && investmentType_1 === EInvestmentType.SIP) {
                setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
            }
        }
    };
    var getMFPurchaseData = function () {
        hendleScreenState(EMutualFundFlow.LOADER);
        var purchasePayload = {
            clientCode: props.clientDetails.clientCode,
            isDirect: true,
            groupCode: schemeGroupCode,
            type: investmentType === EInvestmentType.REDEEM ? "R" : "P",
            isin: investmentType === EInvestmentType.SWP ||
                investmentType === EInvestmentType.STP ||
                investmentType === EInvestmentType.SWITCH
                ? isin
                : undefined,
            trxType: investmentType === EInvestmentType.STP ||
                investmentType === EInvestmentType.SWP ||
                investmentType === EInvestmentType.SWITCH
                ? investmentType
                : undefined,
        };
        if (investmentType === EInvestmentType.REDEEM ||
            investmentType === EInvestmentType.SWP ||
            investmentType === EInvestmentType.STP ||
            investmentType === EInvestmentType.SWITCH) {
            purchasePayload = __assign(__assign({}, purchasePayload), { isin: isin });
        }
        tocDi.tocJourney
            .getMFPurchase(__assign({}, purchasePayload))
            .then(function (data) {
            if (!!data) {
                setParentMfdata(data);
                var index = data.schemePlanList.findIndex(function (item, index) {
                    if (item.shmplan.toLowerCase() === "normal" &&
                        props.schemeplan.toLowerCase() === "regular") {
                        return true;
                    }
                    if (item.shmplan.toLowerCase() === props.schemeplan.toLowerCase()) {
                        return true;
                    }
                });
                setAllMFData(data.schemePlanList[index]);
                setSchemeType(data.schemePlanList[index].shmplan);
                var selectedData = data.schemePlanList[index].returnTypeList.find(function (x) { return x.schemeCodeList.includes(schemeCodeRef.current); });
                if (selectedData) {
                    setMfSelectedData(selectedData, props.schemeplan);
                    setSchemeListKey(selectedData.schemeListKey);
                }
                else {
                    hendleScreenState(EMutualFundFlow.APIERROR);
                    setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
                }
            }
            else {
                hendleScreenState(EMutualFundFlow.APIERROR);
                setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
            }
        })
            .catch(function (error) {
            setPurchaseError(error.message || error.getErrorMessageOrErrMsg());
            hendleScreenState(EMutualFundFlow.APIERROR);
            setOrderStatus(__assign(__assign({}, MFError.Error), { genericDetails: undefined, genericDetailsCollapse: undefined, children: (React.createElement(EdButton, { btnTyp: "blood-red-border", value: "Try Again", onClick: function () {
                        getMFPurchaseData();
                    }, className: "DMSan_14_500 mgr-10 order-status-view-btn" })) }));
        });
    };
    var resetMfData = function (type) {
        var newMfData = parentMfData.schemePlanList.filter(function (item) { return item.shmplan === type; });
        setAllMFData(newMfData[0]);
        setSchemeType(type);
        var selectedData = newMfData[0].returnTypeList[0];
        if (selectedData) {
            setMfSelectedData(selectedData, type);
            setSchemeListKey(selectedData.schemeListKey);
        }
        else {
            hendleScreenState(EMutualFundFlow.APIERROR);
            setOrderStatus(__assign(__assign({}, MFError.noData), { genericDetails: undefined, genericDetailsCollapse: undefined, children: undefined }));
        }
    };
    var getMfBankDetails = function () {
        var _a, _b;
        tocDi.mandate
            .getMfNewBankDetails({
            accId: (_a = props.clientDetails) === null || _a === void 0 ? void 0 : _a.userName,
            accTyp: props.clientDetails.accType,
            clientCode: (_b = props.clientDetails) === null || _b === void 0 ? void 0 : _b.clientCode,
        })
            .then(function (data) {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setBankList(data.data);
                var selectedBank_1 = data.data.find(function (x) { return x.defaultBankRank; });
                if (!selectedBank_1) {
                    selectedBank_1 = data.data[0];
                }
                setSelectedBank(selectedBank_1);
            }
        })
            .catch(function (error) { return console.log(error); });
    };
    var getSipStartDateData = function (frq, fi, mfDa, transactionType) {
        var _a;
        if (frq === void 0) { frq = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency; }
        if (fi === void 0) { fi = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment; }
        if (mfDa === void 0) { mfDa = mfData; }
        if (transactionType === void 0) { transactionType = investmentType; }
        if (!mfDa ||
            (investmentType == EInvestmentType.SIP && !mfDa.sipData) ||
            (investmentType == EInvestmentType.STP && !mfDa.stpData) ||
            (investmentType == EInvestmentType.SWP && !mfDa.swpData)) {
            return;
        }
        var investmentObject = getObjectFromInvestmentType(transactionType, mfDa, frq);
        var payload = {
            amcCode: mfDa === null || mfDa === void 0 ? void 0 : mfDa.amcCode,
            schemeGroupCode: investmentObject === null || investmentObject === void 0 ? void 0 : investmentObject.schemeGroupCode,
            isin: investmentObject === null || investmentObject === void 0 ? void 0 : investmentObject.isin,
            frequency: frq,
            txnType: transactionType === EInvestmentType.SIP ? "XSIP" : transactionType,
            gfot: (props === null || props === void 0 ? void 0 : props.isModify) &&
                ((_a = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _a === void 0 ? void 0 : _a.displayStatus) === EOrderBookStatus.ACTIVE
                ? "N"
                : fi === firstInstallmentConstentEnum.LATER
                    ? "N"
                    : "Y",
            mandateId: (selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId) || "",
        };
        tocDi.tocJourney
            .getSipStartDate(payload)
            .then(function (data) {
            if (data.sipDate.length > 0) {
                // if (!props.isModify) {
                // to set values from order and avoid set default values
                if (!props.isModify) {
                    setPurchaseFormData(function (fData) {
                        return __assign(__assign({}, fData), { sipDate: data.sipDate[0], firstInstallment: fi });
                    });
                }
                setFormErrors(function (error) {
                    return __assign(__assign({}, error), { startDate: { msg: "", status: false } });
                });
                // }
                setStartDate(data.sipDate);
            }
            else {
                setFormErrors(function (error) {
                    return __assign(__assign({}, error), { startDate: { msg: "No Dates Available!!", status: true } });
                });
            }
        })
            .catch(function (err) {
            setFormErrors(function (error) {
                return __assign(__assign({}, error), { startDate: { msg: "No Dates Available!!", status: true } });
            });
            setStartDate([]);
            setPurchaseFormData(function (fData) {
                return __assign(__assign({}, fData), { sipDate: "", firstInstallment: fi });
            });
        });
    };
    var getMfMandate = function () {
        tocDi.mandate
            .getMfMandate({
            clientCode: props.clientDetails.clientCode,
            filterRequired: true,
        })
            .then(function (data) {
            var _a;
            if (data.lst.length > 0) {
                var selectedMandate_1 = null;
                var selectedMandateIdLocal = null;
                var filteredMandateList = __spreadArray([], __read(data.lst), false);
                var selectedMandateIndex = null;
                // incase of post dion modify we are keeping paynow as later hardcoded N
                if (currentfirstInstallmentValueRef.current ===
                    firstInstallmentConstentEnum.LATER ||
                    (props.isModify &&
                        props.mfmodifyData.displayStatus === EOrderBookStatus.ACTIVE)) {
                    filteredMandateList = filteredMandateList.filter(function (item) { return item.dpStatus === "Active"; });
                    if (isEmpty(filteredMandateList)) {
                        selectedMandate_1 = null;
                        selectedMandateIdLocal = null;
                    }
                }
                if (!selectedMandateId && ((_a = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _a === void 0 ? void 0 : _a.mandateId)) {
                    selectedMandateIndex = filteredMandateList.findIndex(function (item) { var _a; return (item === null || item === void 0 ? void 0 : item.mandateId) === ((_a = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _a === void 0 ? void 0 : _a.mandateId); });
                    selectedMandate_1 = filteredMandateList[selectedMandateIndex];
                }
                if (!selectedMandate_1) {
                    // If filteredMandateList is not empty, calculate the max validity object
                    if (!isEmpty(filteredMandateList)) {
                        selectedMandate_1 = filteredMandateList[0]; // Initialize with the first element
                        var maxValidityActiveObject_1 = null;
                        filteredMandateList.forEach(function (obj) {
                            if (new Date(obj.expiryDate) >
                                new Date(selectedMandate_1.expiryDate)) {
                                selectedMandate_1 = obj;
                            }
                            if (obj.dpStatus === "Active" &&
                                (!maxValidityActiveObject_1 ||
                                    new Date(obj === null || obj === void 0 ? void 0 : obj.expiryDate) >
                                        new Date(maxValidityActiveObject_1 === null || maxValidityActiveObject_1 === void 0 ? void 0 : maxValidityActiveObject_1.expiryDate))) {
                                maxValidityActiveObject_1 = obj;
                            }
                        });
                        selectedMandate_1 = maxValidityActiveObject_1 || selectedMandate_1;
                    }
                }
                setMandateList(filteredMandateList);
                setSelectedMandate(selectedMandate_1);
                setSelectedMandateId(selectedMandate_1.mandateId);
            }
        })
            .catch(function (error) { return console.log(error); });
    };
    //setup as reqbody as Invesment Type
    var createRequestBody = function (investmentType, reqbody) {
        switch (investmentType) {
            case EInvestmentType.LUMPSUM:
                reqbody.txnTyp = "LUMPSUM";
                break;
            case EInvestmentType.SIP:
                reqbody.frequency = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency;
                reqbody.startDt = moment(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate, "DD MMM YYYY").format("YYYY-MM-DD");
                reqbody.startDay = Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate.split(" ")[0]);
                reqbody.txnTyp = "XSIP";
                reqbody.generateToday = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment;
                reqbody.mandateId = selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId;
                reqbody.mandateEndDate = selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.expiryDate;
                reqbody.mandateAmount = selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.amount;
                break;
            case EInvestmentType.REDEEM:
                reqbody.txnTyp = "R";
                reqbody.amt = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount);
                if ((purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity) > 0) {
                    reqbody.unit = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity);
                }
                else {
                    reqbody.unit = +roundUpToTwoDecimalPlaces(Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.redeemAmount) / +selectedFolio.nav);
                }
                if (physicalFlg === EHoldingType.Physical)
                    reqbody.folioNum = selectedFolio.folioNo;
                break;
            case EInvestmentType.SWP:
                reqbody.txnTyp = "SWP";
                reqbody.installment = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.installmentCount;
                reqbody.startDt = moment(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate, "DD MMM YYYY").format("YYYY-MM-DD");
                reqbody.unit = +roundUpToTwoDecimalPlaces(Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount) / +selectedFolio.nav);
                reqbody.frequency = "MONTHLY";
                if (physicalFlg === EHoldingType.Physical)
                    reqbody.folioNum = selectedFolio.folioNo;
                break;
            case EInvestmentType.SWITCH:
                // reqbody.frequency = "MONTHLY";
                reqbody.txnTyp = "SWITCH";
                reqbody.switchIsinName = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchTransferTo;
                reqbody.switchIsin = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchIsin;
                reqbody.switchGroupCode = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchGroupCode;
                reqbody.unit = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.unit);
                if (physicalFlg === EHoldingType.Physical)
                    reqbody.folioNum = selectedFolio.folioNo;
                break;
            case EInvestmentType.STP:
                reqbody.frequency = "MONTHLY";
                reqbody.installment = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.installmentCount;
                reqbody.switchIsinName = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchTransferTo;
                reqbody.startDt = moment(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate, "DD MMM YYYY").format("YYYY-MM-DD");
                reqbody.startDay = Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate.split(" ")[0]);
                // reqbody.startDt = purchaseFormData?.startDt;
                // reqbody.startDay = +purchaseFormData?.startDay || undefined;
                // reqbody.installment =
                //   purchaseFormData?.sipValidationCustom === ""
                //     ? purchaseFormData?.sipValidationPreset
                //     : purchaseFormData?.sipValidationCustom;
                reqbody.txnTyp = EInvestmentType.STP;
                reqbody.generateToday = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment;
                reqbody.mandateId = selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId;
                reqbody.switchIsin = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchIsin;
                reqbody.switchGroupCode = purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchGroupCode;
                reqbody.unit = Number(roundUpToTwoDecimalPlaces(Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount) / Number(selectedFolio.nav)));
                if (physicalFlg === EHoldingType.Physical)
                    reqbody.folioNum = selectedFolio.folioNo;
            default:
                break;
        }
    };
    var onSubmitModify = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            investmentServices.modify.submit({
                isModify: props.isModify,
                investmentType: investmentType,
                purchaseFormData: purchaseFormData,
                setOrderStatus: setOrderStatus,
                hendleScreenState: hendleScreenState,
                mfData: mfData,
                externalData: externalData,
                mfmodifyData: props.mfmodifyData,
                setServerError: setServerError,
                clientDetails: props.clientDetails,
                allmfData: allmfData,
                physicalFlg: physicalFlg,
                selectedMandate: selectedMandate,
                selectedFolio: selectedFolio,
            });
            return [2 /*return*/];
        });
    }); };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var investmentObject, payload;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    hendleScreenState(EMutualFundFlow.LOADER);
                    investmentObject = getObjectFromInvestmentType(investmentType, mfData, investmentType === EInvestmentType.SIP
                        ? purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency
                        : "MONTHLY");
                    _a = {
                        token: investmentObject === null || investmentObject === void 0 ? void 0 : investmentObject.token
                    };
                    return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
                case 1:
                    _a.requestedBy = _c.sent();
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 2:
                    payload = (// need change logic
                    _a.loginType = _c.sent(),
                        _a.clientCode = props.clientDetails.clientCode,
                        _a.schemeCode = mfData === null || mfData === void 0 ? void 0 : mfData.schemeCode,
                        _a.isin = investmentObject === null || investmentObject === void 0 ? void 0 : investmentObject.isin,
                        _a.txnTyp = investmentType,
                        _a.amt = Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount),
                        _a.reInvFlg = mfData === null || mfData === void 0 ? void 0 : mfData.reInvFlag,
                        _a.ordTyp = "FRESH",
                        _a.schemeName = mfData === null || mfData === void 0 ? void 0 : mfData.schemeName,
                        _a.ordSrc = "RM_WEB",
                        _a.schemePlan = allmfData.shmplan,
                        _a.physicalFlag = physicalFlg,
                        _a.ucc = props.clientDetails.uniqueClientId,
                        _a.groupCode = allmfData.groupCode,
                        _a.returnType = investmentType === EInvestmentType.SIP || EInvestmentType.SWP
                            ? mfData === null || mfData === void 0 ? void 0 : mfData.returnType
                            : "",
                        _a);
                    createRequestBody(investmentType, payload);
                    if (externalData.isModify === true) {
                        payload.ordTyp = "Modify";
                        payload.txnDt = (_b = externalData.modifyData) === null || _b === void 0 ? void 0 : _b.trxTime;
                        payload.trxId = Number(externalData.modifyData.trxId);
                    }
                    tocDi.tocJourney
                        .mfPurchaseOrder(payload)
                        .then(function (data) {
                        payload.amt = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount);
                        var _a = __read(OrderDetailsDisplay(investmentType, payload, mfData, {
                            schemeName: purchaseFormData.switchTransferTo,
                        }, data), 2), genericDetails = _a[0], genericDetailsCollapse = _a[1];
                        setOrderStatus(__assign(__assign({}, MFStatusDisplay[investmentType][MfStatus.SUCCESS]), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse, children: (React.createElement(React.Fragment, null, investmentType !== EInvestmentType.REDEEM &&
                                investmentType !== EInvestmentType.SWP &&
                                investmentType !== EInvestmentType.STP &&
                                investmentType !== EInvestmentType.SWITCH ? (React.createElement(EdButton, { btnTyp: "blood-red-border", value: "View OrderBook", onClick: function () {
                                    // will be configurable once get the product code from the backend
                                    var redirectParamUrl = "/dashboard/orderbook?productCode=".concat(urlMapper[261], "&categoryCode=261?productType=1");
                                    //const redirectParamUrl = calculateRedirectLink();
                                    // const afterRmjourneys =
                                    //   redirectParamUrl.split("rmjourneys")[1];
                                    navigate(redirectParamUrl);
                                }, className: "DMSan_14_500 mgr-10 order-status-view-btn" })) : null)) }));
                        setTimeout(function () {
                            hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                        }, 500);
                        setServerError(null);
                        props.deleteOrderedItemFromPlaceOrderTable &&
                            props.placeOrderId &&
                            props.deleteOrderedItemFromPlaceOrderTable([props.placeOrderId]);
                    })
                        .catch(function (error) {
                        payload.amt = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount);
                        var _a = __read(OrderDetailsDisplay(investmentType, payload, mfData, {
                            schemeName: purchaseFormData.switchTransferTo,
                        }, undefined, true), 2), genericDetails = _a[0], genericDetailsCollapse = _a[1];
                        var getErrorJSON, err;
                        try {
                            getErrorJSON = JSON.parse(error === null || error === void 0 ? void 0 : error.getErrorMessege());
                        }
                        catch (er) {
                            getErrorJSON = error === null || error === void 0 ? void 0 : error.getErrorMessege();
                        }
                        setServerError(getErrorJSON);
                        if (typeof getErrorJSON === "string") {
                            err = getErrorJSON;
                        }
                        if (typeof getErrorJSON === "object") {
                            err = getErrorJSON
                                .map(function (z, i) {
                                return "".concat(i + 1, ".").concat(z.msg);
                            })
                                .join();
                        }
                        var displayErr = MFStatusDisplay[investmentType][MfStatus.FAILED];
                        if (err) {
                            displayErr = __assign({}, MFStatusDisplay[investmentType][MfStatus.FAILED]);
                        }
                        setOrderStatus(__assign(__assign({}, displayErr), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse, children: (React.createElement(React.Fragment, null, investmentType !== EInvestmentType.REDEEM ? (React.createElement(EdButton, { btnTyp: "blood-red-border", value: "Try Again", onClick: function () {
                                    onSubmit();
                                }, className: "DMSan_14_500 mgr-10 order-status-view-btn" })) : (React.createElement(React.Fragment, null)))) }));
                        setTimeout(function () {
                            hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                        }, 500);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var onPaymentSubmit = function () {
        var _a, _b, _c, _d, _e, _f;
        hendleScreenState(EMutualFundFlow.IBREDIRECT);
        var bank = (_a = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _a === void 0 ? void 0 : _a.getSelectedBank();
        var upi = (_b = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _b === void 0 ? void 0 : _b.getSelectedUPI();
        var method = (_c = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _c === void 0 ? void 0 : _c.getPaymentMethod();
        var allBanks = (_d = paymentRef === null || paymentRef === void 0 ? void 0 : paymentRef.current) === null || _d === void 0 ? void 0 : _d.getBankDetails();
        if (method === EPaymentType.NetBanking)
            hendleScreenState(EMutualFundFlow.IBREDIRECT);
        else
            hendleScreenState(EMutualFundFlow.LOADER);
        setPaymentMethod(method);
        setSelectedBank(bank);
        var payload = {
            // exOrdNo: externalData.isRetryPayment
            //   ? externalData.modifyData.exOrdNo
            //   : "",
            orderNo: externalData.isRetryPayment
                ? externalData.modifyData.trxId
                : orderData.ordNo,
            amount: externalData.isRetryPayment
                ? externalData.modifyData.amount
                : purchaseFormData.amount,
        };
        if (method === EPaymentType.NetBanking) {
            payload = __assign(__assign({}, payload), { source: "OP", bankAccount: bank === null || bank === void 0 ? void 0 : bank.bnkAcNo, ifsc: bank === null || bank === void 0 ? void 0 : bank.ifscCode, bankCd: (_e = bank === null || bank === void 0 ? void 0 : bank.bankCd) === null || _e === void 0 ? void 0 : _e.toString(), mode: (bank === null || bank === void 0 ? void 0 : bank.brn) ? bank === null || bank === void 0 ? void 0 : bank.brn : "" });
        }
        if (method === EPaymentType.UPI) {
            var upiBankDtls = (_f = allBanks.bnkAcs) === null || _f === void 0 ? void 0 : _f.find(function (bank) {
                return bank.bnkAccNo == upi.bankaccountnumber;
            });
            payload = __assign(__assign({}, payload), { upi: upi === null || upi === void 0 ? void 0 : upi.upi, bankAccount: upi === null || upi === void 0 ? void 0 : upi.bankaccountnumber, bankCd: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.bnkCode, ifsc: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.ifsc, mode: (upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.bankTyp) ? upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.bankTyp : "" });
            setSelectedUpi({
                upi: upi === null || upi === void 0 ? void 0 : upi.upi,
                bankAcnt: upi === null || upi === void 0 ? void 0 : upi.bankaccountnumber,
                bankCd: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.bnkCode,
                ifsc: upiBankDtls === null || upiBankDtls === void 0 ? void 0 : upiBankDtls.ifsc,
            });
        }
        if (investmentType === EInvestmentType.SIP) {
            payload.mandateId = externalData.isRetryPayment
                ? externalData.modifyData.mandateId
                : selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId;
        }
        if (method === EPaymentType.NetBanking) {
            var screenWidth = window.screen.width;
            var screenHeight = window.screen.height;
            windowIB = window.open(config.rootUrl + "mutualFund/loading", "", "width=1000,height=800,left=".concat((screenWidth - 1000) / 2, ",top=").concat((screenHeight - 800) / 2));
        }
        tocDi.payment
            .tradePayment(payload)
            .then(function (data) {
            if (method === EPaymentType.NetBanking) {
                if ((data === null || data === void 0 ? void 0 : data.responsestring) && (data === null || data === void 0 ? void 0 : data.exOrdNo)) {
                    var backendHtmlString_1 = data.responsestring.toString();
                    var extractedScript_1 = /<script>[\s\S]*<\/script>/g.exec(backendHtmlString_1);
                    windowIB.location.href =
                        config.rootUrl + "mutualFund/IB/redirecting";
                    // const screenWidth = window.screen.width;
                    // const screenHeight = window.screen.height;
                    // windowIB = window.open(
                    //   config.rootUrl + "mutualFund/IB/redirecting",
                    //   "",
                    //   `width=1000,height=800,left=${(screenWidth - 1000) / 2},top=${
                    //     (screenHeight - 800) / 2
                    //   }`
                    // );
                    //config.rootUrl + "mutualFund/IB/redirecting",
                    setTimeout(function () {
                        windowIB.postMessage({ html: backendHtmlString_1, script: extractedScript_1[0] }, window.location.origin);
                        hendleScreenState(EMutualFundFlow.IBPAGENOTE);
                    }, 2000);
                    var timer = setInterval(function () {
                        if (windowIB.closed) {
                            window.blur();
                            setTimeout(function () {
                                window.focus();
                            }, 100);
                            getOrderStatus(0);
                            clearInterval(timer);
                        }
                    }, 500);
                }
            }
            else if (method === EPaymentType.UPI) {
                if ((data === null || data === void 0 ? void 0 : data.responsestring) && (data === null || data === void 0 ? void 0 : data.exOrdNo)) {
                    hendleScreenState(EMutualFundFlow.UPIAPPROVAL);
                }
            }
        })
            .catch(function (err) {
            // setOrderStatusData(EMFType.PURCHASE, MfStatus.FAILED, false);
            hendleScreenState(EMutualFundFlow.PAYEMENTSTATUS);
            setServerError(err.getErrorMessege());
        });
    };
    var getOrderStatus = function (time) {
        if (time % 5 === 0) {
            tocDi.payment
                .getMfPaymentStatus({
                ordNo: externalData.isRetryPayment
                    ? externalData.modifyData.trxId
                    : orderData.ordNo,
                txnDt: moment().format("YYYY-MM-DD"),
                exOrdNo: "",
                pay: paymentMethod === EPaymentType.UPI ? "true" : "",
            })
                .then(function (data) {
                if (data === null || data === void 0 ? void 0 : data.status) {
                    if ((time < 1 &&
                        (data.status == "CONTINUE" || data.status == "ERROR")) ||
                        (data.status != "ERROR" && data.status != "CONTINUE")) {
                        var status_1 = getStatusType(data.status);
                        //setOrderStatusData(EMFType.PURCHASE, status, false);
                        hendleScreenState(EMutualFundFlow.PAYEMENTSTATUS);
                    }
                }
            })
                .catch(function (err) {
                // setOrderStatusData(EMFType.PURCHASE, MfStatus.FAILED, false);
                hendleScreenState(EMutualFundFlow.PAYEMENTSTATUS);
                setServerError(err.getErrorMessege());
            });
        }
    };
    var getStatusType = function (status) {
        switch (status) {
            case "SUCCESS":
                return MfStatus.SUCCESS;
            case "CONTINUE":
                return MfStatus.PENDING;
            case "RETRY":
                return MfStatus.FAILED;
            case "PENDING":
                return MfStatus.PENDING;
            case "ERROR":
                return MfStatus.FAILED;
        }
    };
    var redirectFunction = function () {
        if (device === null || device === void 0 ? void 0 : device.isDesktop)
            props.setShowTOC();
        else
            (locationState === null || locationState === void 0 ? void 0 : locationState.redirectUrl)
                ? navigate(locationState.redirectUrl.replace(config.subDomain, ""))
                : (props === null || props === void 0 ? void 0 : props.redirectUrl)
                    ? navigate(props === null || props === void 0 ? void 0 : props.redirectUrl.replace(config.subDomain, ""))
                    : (locationState === null || locationState === void 0 ? void 0 : locationState.prevUrl)
                        ? navigate(locationState === null || locationState === void 0 ? void 0 : locationState.prevUrl)
                        : navigate("/");
    };
    var getLinkedSipData = function (mandateId) { return __awaiter(void 0, void 0, void 0, function () {
        var linkedSipResp, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, basicProfileDi.basicProfile.mandateLinkedSip({
                            mandateId: mandateId,
                        })];
                case 1:
                    linkedSipResp = _b.sent();
                    setLinkedSipData(((_a = linkedSipResp === null || linkedSipResp === void 0 ? void 0 : linkedSipResp.data) === null || _a === void 0 ? void 0 : _a.linkedSips) || []);
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _b.sent();
                    console.log("err", err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRightBtnOnClickForFooter = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // if (tocFlow === EMutualFundFlow.PURCHASE) {
        //   // orderConfrimation(EMFType.PURCHASE);
        // }
        if (tocFlow === EMutualFundFlow.MANDATE) {
            setSelectedMandate(mandateList === null || mandateList === void 0 ? void 0 : mandateList.find(function (x) { return x.mandateId === selectedMandateId; }));
            setTOCFlow(EMutualFundFlow.PURCHASE);
        }
        else {
            var closeTOCSideBarForTheseInvestmentTypes = new Set([
                EInvestmentType.REDEEM,
                EInvestmentType.CANCEL,
                EInvestmentType.PAUSE,
                EInvestmentType.RESUME,
                EInvestmentType.SWP,
                EInvestmentType.STP,
                EInvestmentType.SWITCH,
            ]);
            if (closeTOCSideBarForTheseInvestmentTypes.has(investmentType) ||
                props.isModify) {
                hideTOCSideBar(__spreadArray([], __read(args), false));
                if (
                // investmentType === EInvestmentType.REDEEM &&
                props.sourcePage === ESourcePage.PRODUCT_PAGE) {
                    var redirectParamUrl = "/dashboard/orderbook?productCode=".concat(urlMapper[261], "&categoryCode=261?productType=1");
                    navigate(redirectParamUrl);
                }
            }
        }
    };
    var getErrorMessage = function (error) {
        var getErrorJSON, err;
        try {
            getErrorJSON = JSON.parse(error === null || error === void 0 ? void 0 : error.getErrorMessege());
        }
        catch (er) {
            getErrorJSON = error === null || error === void 0 ? void 0 : error.getErrorMessege();
        }
        setServerError(getErrorJSON);
        if (typeof getErrorJSON === "string") {
            err = getErrorJSON;
        }
        if (typeof getErrorJSON === "object") {
            err = getErrorJSON
                .map(function (z, i) {
                return "".concat(i + 1, ".").concat(z.msg);
            })
                .join();
        }
        var displayErr = MFStatusDisplay[investmentType][MfStatus.FAILED];
        if (err) {
            displayErr = __assign({}, MFStatusDisplay[investmentType][MfStatus.FAILED]);
        }
        var errCode = error.getErrorCode();
        if (errCode === EErrorCodes.ER1014) {
            displayErr.description = error.getErrorMessege();
        }
        return displayErr;
    };
    function getTxntype(mfmodifyData) {
        var type = mfmodifyData === null || mfmodifyData === void 0 ? void 0 : mfmodifyData.displayTransactionType;
        if (!type)
            return "";
        var lowerType = type.toLowerCase();
        switch (true) {
            case type === EInvestmentType.SIP:
            case type.includes(EInvestmentType.SIP):
                return "XSIP";
            case lowerType === EInvestmentType.REDEEM.toLowerCase():
                return "R";
            case type.includes(EInvestmentType.SWP):
                return EInvestmentType.SWP;
            case type.includes(EInvestmentType.STP):
                return EInvestmentType.STP;
            default:
                return type.toUpperCase();
        }
    }
    var cancelSip = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        var _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    hendleScreenState(EMutualFundFlow.LOADER);
                    _b = (_a = tocDi.tocJourney)
                        .mfCancelOrder;
                    _c = {
                        token: (_e = (_d = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _d === void 0 ? void 0 : _d.scheme) === null || _e === void 0 ? void 0 : _e.token
                    };
                    return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
                case 1:
                    _c.requestedBy = _u.sent();
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 2:
                    _b.apply(_a, [(// need change logic
                        _c.loginType = _u.sent(),
                            _c.clientCode = props.clientDetails.clientCode,
                            _c.schemeCode = (_g = (_f = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _f === void 0 ? void 0 : _f.scheme) === null || _g === void 0 ? void 0 : _g.schemeCode,
                            _c.isin = isin,
                            _c.trxId = (_h = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _h === void 0 ? void 0 : _h.trxId,
                            _c.txnType = getTxntype(externalData === null || externalData === void 0 ? void 0 : externalData.modifyData),
                            _c.vendorTrxId = (_j = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _j === void 0 ? void 0 : _j.vendorTrxId,
                            _c.ordSrc = "RM_WEB",
                            _c.schemeName = (_l = (_k = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _k === void 0 ? void 0 : _k.scheme) === null || _l === void 0 ? void 0 : _l.schemeName,
                            _c.invActionCode = (_m = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _m === void 0 ? void 0 : _m.invActionCode,
                            _c.amt = (_o = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _o === void 0 ? void 0 : _o.amount,
                            _c.deliveryMode = (_p = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _p === void 0 ? void 0 : _p.investmentType,
                            _c.dpTrxId = (_q = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _q === void 0 ? void 0 : _q.displayTransactionId,
                            _c.frequency = (_r = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _r === void 0 ? void 0 : _r.frequency,
                            _c.numberOfInstallment = (_s = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _s === void 0 ? void 0 : _s.totalNoOfInstallments,
                            _c.registrationNumber = (_t = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _t === void 0 ? void 0 : _t.registrationNumber,
                            _c)])
                        .then(function (x) {
                        var _a, _b, _c;
                        if (!isEmpty(serverError))
                            setServerError(null);
                        if ((_a = x === null || x === void 0 ? void 0 : x.data) === null || _a === void 0 ? void 0 : _a.dpOrderNum)
                            externalData.modifyData.displayTransactionId = (_b = x === null || x === void 0 ? void 0 : x.data) === null || _b === void 0 ? void 0 : _b.dpOrderNum;
                        var _d = __read(OrderDetailsDisplay(investmentType, null, null, null, externalData === null || externalData === void 0 ? void 0 : externalData.modifyData), 2), genericDetails = _d[0], genericDetailsCollapse = _d[1];
                        setOrderStatus(__assign(__assign({}, MFStatusDisplay[investmentType][MfStatus.SUCCESS]), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse, title: "".concat((_c = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _c === void 0 ? void 0 : _c.displayTransactionType, " cancellation request has been successfully submitted") }));
                        hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                    })
                        .catch(function (error) {
                        var _a = __read(OrderDetailsDisplay(investmentType, null, null, null, externalData.modifyData, true), 2), genericDetails = _a[0], genericDetailsCollapse = _a[1];
                        var displayErr = getErrorMessage(error);
                        setOrderStatus(__assign(__assign({}, displayErr), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse, children: React.createElement(React.Fragment, null) }));
                        hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var pauseSIP = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        var _c;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    hendleScreenState(EMutualFundFlow.LOADER);
                    _b = (_a = tocDi.tocJourney)
                        .mfPauseResume;
                    _c = {};
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 1:
                    _c.loginType = _e.sent(),
                        _c.clientCode = props.clientDetails.clientCode;
                    return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
                case 2:
                    _b.apply(_a, [(_c.requestedBy = _e.sent(),
                            _c.trxId = externalData.modifyData.trxId,
                            _c.installment = String(Number(mfData === null || mfData === void 0 ? void 0 : mfData.sipData[externalData.modifyData.frequency].pauseMaxInst)),
                            _c.registrationNumber = (_d = externalData.modifyData) === null || _d === void 0 ? void 0 : _d.registrationNumber,
                            _c.txnType = "XSIP",
                            _c.action = EActionTypeForPause.PAUSE,
                            _c.schemeCode = mfData === null || mfData === void 0 ? void 0 : mfData.schemeCode,
                            _c.vendorTrxId = externalData.modifyData.vendorTrxId,
                            _c.groupCode = externalData.modifyData.groupCode,
                            _c.isin = externalData.modifyData.ISIN,
                            _c.schemeName = mfData.schemeName,
                            _c.ordSrc = "RM_WEB",
                            _c.amt = externalData.modifyData.amount,
                            _c.deliveryMode = externalData.modifyData.investmentType,
                            _c.dpTrxId = externalData.modifyData.displayTransactionId,
                            _c.frequency = externalData.modifyData.frequency,
                            _c)])
                        .then(function (response) {
                        var _a = __read(OrderDetailsDisplay(investmentType, undefined, mfData, undefined, __assign(__assign({}, externalData), { apiResponse: response })), 2), genericDetails = _a[0], genericDetailsCollapse = _a[1];
                        setOrderStatus(__assign(__assign({}, MFStatusDisplay[investmentType][MfStatus.SUCCESS]), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse }));
                        hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                    })
                        .catch(function (error) {
                        var displayErr = getErrorMessage(error);
                        setOrderStatus(__assign(__assign({}, displayErr), { children: React.createElement(React.Fragment, null) }));
                        hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var resumeSIP = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    hendleScreenState(EMutualFundFlow.LOADER);
                    _b = (_a = tocDi.tocJourney)
                        .mfPauseResume;
                    _c = {};
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 1:
                    _c.loginType = _d.sent(),
                        _c.clientCode = props.clientDetails.clientCode;
                    return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
                case 2:
                    _b.apply(_a, [(_c.requestedBy = _d.sent(),
                            _c.trxId = externalData.modifyData.trxId,
                            _c.installment = "0",
                            _c.registrationNumber = externalData.modifyData.registrationNumber,
                            _c.txnType = "XSIP",
                            _c.action = EActionTypeForPause.RESUME,
                            _c.schemeCode = mfData === null || mfData === void 0 ? void 0 : mfData.schemeCode,
                            _c.vendorTrxId = externalData.modifyData.vendorTrxId,
                            _c.groupCode = externalData.modifyData.groupCode,
                            _c.isin = externalData.modifyData.ISIN,
                            _c.schemeName = mfData.schemeName,
                            _c.ordSrc = "RM_WEB",
                            _c.amt = externalData.modifyData.amount,
                            _c.deliveryMode = externalData.modifyData.investmentType,
                            _c.dpTrxId = externalData.modifyData.displayTransactionId,
                            _c.frequency = externalData.modifyData.frequency,
                            _c)])
                        .then(function (response) {
                        var _a = __read(OrderDetailsDisplay(investmentType, undefined, mfData, undefined, __assign(__assign({}, externalData), { apiResponse: response })), 2), genericDetails = _a[0], genericDetailsCollapse = _a[1];
                        setOrderStatus(__assign(__assign({}, MFStatusDisplay[investmentType][MfStatus.SUCCESS]), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse }));
                        hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                    })
                        .catch(function (error) {
                        var displayErr = getErrorMessage(error);
                        setOrderStatus(__assign(__assign({}, displayErr), { children: React.createElement(React.Fragment, null) }));
                        hendleScreenState(EMutualFundFlow.ORDER_STATUS);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var modifyOrder = function (e) {
        if (e) {
            e.preventDefault();
        }
        investmentServices.modify.confirmationScreen({
            investmentType: investmentType,
            purchaseFormData: purchaseFormData,
            selectedMandate: selectedMandate,
            setOrderStatus: setOrderStatus,
            hendleScreenState: hendleScreenState,
        });
    };
    var hideTOCSideBar = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        props.setShowTOC.apply(props, __spreadArray([false], __read(args), false));
    };
    var setInvestmentTypeWithDates = function (investmentType) {
        setInvestmentType(investmentType);
        investmentTypeRef.current = investmentType;
        if (investmentType === EInvestmentType.SIP && !startDate) {
            getMfMandate();
            getSipStartDateData(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, mfData, investmentType);
        }
    };
    // *******************************************
    // *           useEffects                    *
    // *******************************************
    useEffect(function () {
        if (investmentTypeRef.current && (mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag) && !(mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag)) {
            investmentTypeRef.current = EInvestmentType.SIP;
        }
    }, [mfData === null || mfData === void 0 ? void 0 : mfData.returnType]);
    useEffect(function () {
        var _a;
        if (investmentType === EInvestmentType.CANCEL) {
            hendleScreenState(EMutualFundFlow.CANCEL);
        }
        else if (!props.isTriggeredFromOrderBook) {
            getMFPurchaseData();
        }
        if (investmentType !== EInvestmentType.CANCEL)
            getCategoryListings();
        setPurchaseFormData({
            amount: externalData.isModify ? (_a = externalData.modifyData) === null || _a === void 0 ? void 0 : _a.amount : "",
            firstInstallment: firstInstallmentConstentEnum.NOW,
            sipFrequency: externalData.isModify
                ? externalData.modifyData.frequency
                : "",
            sipDate: moment(externalData.modifyData.nextInstallmentDate).format("DD MMM YYYY"),
            sipValidationPreset: validityRadio[0].value,
            sipValidationCustom: "",
        });
    }, []);
    useEffect(function () {
        if (!externalData.isModify && ifNfo !== "nfo") {
            // avoid set default values
            setPurchaseFormData(function (pData) {
                return __assign(__assign({}, pData), { amount: "" });
            });
        }
        setFormErrors({
            amount: { msg: "", status: false },
            installmentCount: { msg: "", status: false },
            mandateId: { msg: "", status: false },
        });
    }, [investmentType]);
    useEffect(function () {
        var _a, _b, _c;
        if ((mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.dematHldQty) &&
            (mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.physHldQty) &&
            tocFlow === EMutualFundFlow.REDEEM) {
            if (((_a = mfHoldingData.dematHldQty) === null || _a === void 0 ? void 0 : _a.length) === 0 &&
                mfHoldingData.physHldQty.length === 0)
                setRedeemError(true);
        }
        if (((_b = mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.physHldQty) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
            ((_c = mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.dematHldQty) === null || _c === void 0 ? void 0 : _c.length) === 0)
            setRedeemType(EReedemType.PHYSICAL);
        if ((mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.physHldQty) && tocFlow === EMutualFundFlow.REDEEM) {
            if (mfHoldingData.physHldQty.length > 0) {
                setFolioList(mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.physHldQty);
                setFolio(mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.physHldQty[0]);
            }
        }
    }, [mfHoldingData, tocFlow]);
    useEffect(function () {
        if (mfData) {
            var updateMandateListWithErrorsIfAny = function () {
                var errorObj = { hasError: false, errorMessage: "" };
                var selectedMandateErrorObj = { hasError: false, errorMessage: "" };
                // getting sip data as null
                if (!(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate) || !(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency))
                    return;
                var updatedMandateListWithErrors = mandateList === null || mandateList === void 0 ? void 0 : mandateList.map(function (item) {
                    var _a;
                    var validatedInstallmentsForSIP = getValidatedInstallmentForSIPMandate(item === null || item === void 0 ? void 0 : item.expiryDate, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency) || 90;
                    // temporary fix as sipFrequency, sipDate is coming as epmty
                    var minimumInstallmentNumber = +((_a = mfData === null || mfData === void 0 ? void 0 : mfData.sipData[purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency]) === null || _a === void 0 ? void 0 : _a.minInstNum) || 100;
                    var installmentNumberError = validatedInstallmentsForSIP < minimumInstallmentNumber;
                    var installmentAmountError = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount) > +(item === null || item === void 0 ? void 0 : item.amount);
                    if (installmentNumberError) {
                        errorObj = {
                            hasError: true,
                            errorMessage: "The selected mandate doesn’t meet the minimum tenure for this scheme.",
                        };
                    }
                    else if (installmentAmountError) {
                        errorObj = {
                            hasError: true,
                            errorMessage: "The SIP amount exceeds the mandate limit.",
                        };
                    }
                    else {
                        errorObj = {
                            hasError: false,
                            errorMessage: "",
                        };
                    }
                    if (item.mandateId === selectedMandateId) {
                        selectedMandateErrorObj = errorObj;
                    }
                    return __assign(__assign({}, item), errorObj);
                });
                // set remove errors as well
                if (!_.isEqual(mandateList, updatedMandateListWithErrors)) {
                    setMandateList(updatedMandateListWithErrors);
                }
                setFormErrors(function (prev) {
                    return __assign(__assign({}, prev), { mandateId: {
                            msg: selectedMandateErrorObj.errorMessage,
                            status: selectedMandateErrorObj.hasError,
                        } });
                });
            };
            updateMandateListWithErrorsIfAny();
        }
    }, [
        purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount,
        purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate,
        selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId,
    ]);
    useEffect(function () {
        if (tocFlow === EMutualFundFlow.NEWMANDATE) {
            getMfBankDetails();
            setMandateFlow(EMandateFlow.CREATE);
        }
    }, [tocFlow]);
    // const calculateRedirectLink = () => {
    //   try {
    //     // Find the index of the matching Wealth Product
    //     const mfL2LevelData = productCategoryData.mfL2LevelData["Wealth Product"];
    //     const wealthProductIndex = mfL2LevelData.findIndex(
    //       (wealthProduct: IMutualFundsCategoryDataEntity) => {
    //         return (
    //           wealthProduct.value === props.productCode ||
    //           +wealthProduct.value === +urlMapper[props.categoryCode]
    //         );
    //       }
    //     );
    //     // Find the index of the matching category within mfL3LevelData
    //     const categoryIndex = mfL2LevelData[
    //       wealthProductIndex
    //     ].mfL3LevelData.findIndex((category: any) => {
    //       return category.eventKey === +props.categoryCode;
    //     });
    //     // Return the URL for the matched category
    //     return mfL2LevelData[wealthProductIndex].mfL3LevelData[categoryIndex].url;
    //   } catch (e) {}
    // };
    var isShowReturnType = function (type) {
        return ![
            EInvestmentType.REDEEM,
            EInvestmentType.SWP,
            EInvestmentType.STP,
            EInvestmentType.SWITCH,
        ].includes(type);
    };
    var TOCFlow = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35;
        switch (tocFlow) {
            case EMutualFundFlow.LOADER:
                return React.createElement(Loader, null);
            case EMutualFundFlow.APIERROR:
                return (React.createElement(React.Fragment, null,
                    !isEmpty(mfData) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, HandleResetMfData: resetMfData, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentTypeWithDates, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: isShowReturnType(investmentType), setShow: setShowScheme, show: showScheme })),
                    React.createElement("div", { className: "d-flex flex-column height-100" },
                        React.createElement(SideBarClientDetails, __assign({}, props.clientDetails, { clientTier: (_a = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _a === void 0 ? void 0 : _a.clientTier })),
                        React.createElement(OrderStatusScreen, __assign({ hideHeader: true }, orderStatus, { callbackOnContainerClick: function () { return setShowScheme(false); } })),
                        React.createElement("div", { className: "bottom-contents mf-footer-contents" },
                            React.createElement(SideTxnFooter, { leftBtnText: "Cancel", leftBtnOnClick: hideTOCSideBar, rightBtnText: "Go Back", rightBtnOnClick: hideTOCSideBar })))));
            case EMutualFundFlow.PURCHASE:
                return (React.createElement(React.Fragment, null,
                    !isEmpty(mfData) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, HandleResetMfData: resetMfData, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: (_b = investmentTypeRef.current) !== null && _b !== void 0 ? _b : investmentType, setInvestmentType: setInvestmentTypeWithDates, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, schemeCode: schemeCode, setShow: setShowScheme, show: showScheme })),
                    React.createElement(SideBarClientDetails, __assign({}, props.clientDetails, { clientTier: (_c = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _c === void 0 ? void 0 : _c.clientTier, parentClassName: "mf-purchase-sidebar-client-details-container" })),
                    React.createElement("form", { onSubmit: props.isModify ? modifyOrder : onSubmit, className: "d-flex flex-column flex-grow-1" },
                        React.createElement(MutualFundTransaction, { isModify: externalData.isModify
                                ? externalData.isModify
                                : ifNfo === "nfo"
                                    ? true
                                    : false, setShowScheme: setShowScheme, startDate: startDate, setTOCFlow: hendleScreenState, selectedMandate: selectedMandate, investmentType: investmentType, mfData: mfData, MandateError: MandateError, hendleScreenState: hendleScreenState, setStartDate: setStartDate, getSipStartDateData: getSipStartDateData, purchaseFormData: purchaseFormData, setPurchaseFormData: setPurchaseFormData, purchaseType: mfHoldingData === null || mfHoldingData === void 0 ? void 0 : mfHoldingData.purchaseType, physicalFlg: physicalFlg, setPhysicalFlg: setPhysicalFlg, schemeCode: schemeCode, setSelectedMandate: setSelectedMandate, setSelectedMandateId: setSelectedMandateId, setFormErrors: setFormErrors, formErrors: formErrors, setMandateList: setMandateList, mandateList: mandateList, getMfMandate: getMfMandate, availableHoldings: availableHoldings, currentfirstInstallmentValueRef: currentfirstInstallmentValueRef, setIsSipCalendarOpen: setIsCalendarOpen, displayStatus: (_d = props.mfmodifyData) === null || _d === void 0 ? void 0 : _d.displayStatus }),
                        React.createElement("div", { className: "bottom-contents ".concat(props.isModify ? "mf-footer-contents" : "single-btn-footer") },
                            React.createElement(SideTxnFooter
                            // As the "Save to Basket" functionality is not yet available
                            , { 
                                // As the "Save to Basket" functionality is not yet available
                                leftBtnText: props.isModify ? "Cancel" : undefined, leftBtnOnClick: function (e) {
                                    if (props === null || props === void 0 ? void 0 : props.isModify)
                                        props.setShowTOC(false);
                                    else {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }, rightBtnText: props.isModify ? "Update Order" : "Place Single Order", rightBtnSubmit: true, isDisableButton: purchaseApplyBtnDisabled })))));
            case EMutualFundFlow.REDEEM:
                return (React.createElement(React.Fragment, null,
                    !isEmpty(mfData) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: false, setShow: setShowScheme, show: showScheme })),
                    React.createElement(SideBarClientDetails, __assign({}, props.clientDetails, { clientTier: (_e = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _e === void 0 ? void 0 : _e.clientTier })),
                    !redeemError && (React.createElement(RedeemParent, { mfHoldingDetail: mfHoldingDetail, purchaseFormData: purchaseFormData, tocFlow: tocFlow, redeemValObj: (_f = mfData === null || mfData === void 0 ? void 0 : mfData.redeemData) === null || _f === void 0 ? void 0 : _f["MONTHLY"], startDate: startDate, setPurchaseFormData: setPurchaseFormData, onSubmit: onSubmit, rightBtnText: props.isModify ? "Modify" : "Redeem", setFolio: setSelectedFolio, folio: selectedFolio, schemeName: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, maxRedAmt: (_h = (_g = mfData === null || mfData === void 0 ? void 0 : mfData.redeemData) === null || _g === void 0 ? void 0 : _g["MONTHLY"]) === null || _h === void 0 ? void 0 : _h.maxRedAmt, minRedAmt: (_k = (_j = mfData === null || mfData === void 0 ? void 0 : mfData.redeemData) === null || _j === void 0 ? void 0 : _j["MONTHLY"]) === null || _k === void 0 ? void 0 : _k.minRedAmt, minRedQty: +((_m = (_l = mfData === null || mfData === void 0 ? void 0 : mfData.redeemData) === null || _l === void 0 ? void 0 : _l["MONTHLY"]) === null || _m === void 0 ? void 0 : _m.minRedQty), 
                        // purchaseAmtMul={mfData?.purchaseAmtMul}
                        redAmtMul: (_p = (_o = mfData === null || mfData === void 0 ? void 0 : mfData.redeemData) === null || _o === void 0 ? void 0 : _o["MONTHLY"]) === null || _p === void 0 ? void 0 : _p.redAmtMul, setShowTOC: props.setShowTOC, setPhysicalFlag: setPhysicalFlg, isModify: props.isModify, modifyOrder: modifyOrder, onSubmitModify: onSubmitModify }))));
            case EMutualFundFlow.SWP:
                return (React.createElement(React.Fragment, null,
                    !isEmpty(mfData) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: false, setShow: setShowScheme, show: showScheme })),
                    React.createElement(SideBarClientDetails, __assign({}, props.clientDetails, { clientTier: (_q = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _q === void 0 ? void 0 : _q.clientTier })),
                    !redeemError && (React.createElement(RedeemParent, { mfHoldingDetail: mfHoldingDetail, purchaseFormData: purchaseFormData, tocFlow: tocFlow, redeemValObj: (_r = mfData === null || mfData === void 0 ? void 0 : mfData.swpData) === null || _r === void 0 ? void 0 : _r["MONTHLY"], startDate: startDate, setPurchaseFormData: setPurchaseFormData, onSubmit: onSubmit, rightBtnText: "Create SWP", schemeName: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, maxRedAmt: (_t = (_s = mfData === null || mfData === void 0 ? void 0 : mfData.swpData) === null || _s === void 0 ? void 0 : _s["MONTHLY"]) === null || _t === void 0 ? void 0 : _t.maxInstAmt, minRedAmt: (_v = (_u = mfData === null || mfData === void 0 ? void 0 : mfData.swpData) === null || _u === void 0 ? void 0 : _u["MONTHLY"]) === null || _v === void 0 ? void 0 : _v.minInstAmt, purchaseAmtMul: (_x = (_w = mfData === null || mfData === void 0 ? void 0 : mfData.swpData) === null || _w === void 0 ? void 0 : _w["MONTHLY"]) === null || _x === void 0 ? void 0 : _x.mul, setShowTOC: props.setShowTOC, isModify: props.isModify, setPhysicalFlag: setPhysicalFlg, setFolio: setSelectedFolio, folio: selectedFolio, onSubmitModify: onSubmitModify }))));
            case EMutualFundFlow.SCHEME:
                return (React.createElement(SelectScheme, { ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, schemeType: schemeType, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, schemeCode: schemeCode }));
            case EMutualFundFlow.BANKACCOUNT:
                return (React.createElement(DiffrentBankAccount, { back: function () { return hendleScreenState(previousScreenState); }, next: function () { return hendleScreenState(previousScreenState); }, bankList: bankList, setShow: function () { return hendleScreenState(EMutualFundFlow.PURCHASE); }, setSelectedBank: setSelectedBank, selectedBank: selectedBank }));
            case EMutualFundFlow.PAYMENT:
                return (React.createElement(PaymentMethod, { setSelectedBank: setSelectedBank, back: function () {
                        props.isRetryPayment || (locationState === null || locationState === void 0 ? void 0 : locationState.isRetryPayment)
                            ? redirectFunction()
                            : hendleScreenState(EMutualFundFlow.PURCHASE);
                    }, next: function () { return hendleScreenState(EMutualFundFlow.PURCHASE); }, ref: paymentRef, onSubmit: onPaymentSubmit }));
            case EMutualFundFlow.ORDER_STATUS:
                return (React.createElement(React.Fragment, null,
                    React.createElement(MFTocHeader, { schemeList: investmentType === EInvestmentType.CANCEL
                            ? null
                            : parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: investmentType === EInvestmentType.CANCEL
                            ? (_z = (_y = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _y === void 0 ? void 0 : _y.scheme) === null || _z === void 0 ? void 0 : _z.schemeName
                            : mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: investmentType === EInvestmentType.CANCEL
                            ? (_1 = (_0 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _0 === void 0 ? void 0 : _0.scheme) === null || _1 === void 0 ? void 0 : _1.catName
                            : mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: investmentType === EInvestmentType.CANCEL
                            ? (_3 = (_2 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _2 === void 0 ? void 0 : _2.scheme) === null || _3 === void 0 ? void 0 : _3.subCatName
                            : mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: investmentType === EInvestmentType.CANCEL
                            ? (_5 = (_4 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _4 === void 0 ? void 0 : _4.scheme) === null || _5 === void 0 ? void 0 : _5.schPlan
                            : schemeType, maxWidth: 400, returnType: investmentType === EInvestmentType.CANCEL
                            ? null
                            : mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: investmentType === EInvestmentType.CANCEL
                            ? null
                            : allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: investmentType === EInvestmentType.CANCEL ? null : changeScheme, divFrq: investmentType === EInvestmentType.CANCEL
                            ? null
                            : allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: investmentType === EInvestmentType.CANCEL
                            ? false
                            : mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: investmentType === EInvestmentType.CANCEL
                            ? false
                            : mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: investmentType === EInvestmentType.CANCEL
                            ? false
                            : externalData.isModify
                                ? externalData.isModify
                                : ifNfo === "nfo"
                                    ? true
                                    : false, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: false, setShow: setShowScheme, show: showScheme }),
                    (props === null || props === void 0 ? void 0 : props.clientDetails) && (React.createElement(SideBarClientDetails, __assign({}, props === null || props === void 0 ? void 0 : props.clientDetails, { clientTier: (_6 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _6 === void 0 ? void 0 : _6.clientTier }))),
                    React.createElement(OrderStatusScreen, __assign({ hideHeader: true }, orderStatus)),
                    props.isModify ||
                        (investmentType !== EInvestmentType.SIP &&
                            investmentType !== EInvestmentType.LUMPSUM) ? (React.createElement("div", { className: "bottom-contents" },
                        React.createElement(SideTxnFooter, { leftBtnText: "Close", leftBtnOnClick: handleRightBtnOnClickForFooter, rightBtnText: !serverError ? "View Orderbook" : "Try again", rightBtnOnClick: function () {
                                if (serverError) {
                                    if (props.isModify)
                                        onSubmitModify();
                                    else {
                                        switch (investmentType) {
                                            case EInvestmentType.CANCEL:
                                                cancelSip();
                                                break;
                                            case EInvestmentType.PAUSE:
                                                pauseSIP();
                                            case EInvestmentType.RESUME:
                                                resumeSIP();
                                                break;
                                            default:
                                                onSubmit();
                                                break;
                                        }
                                    }
                                }
                                else {
                                    // Default action when there’s no server error
                                    handleRightBtnOnClickForFooter({
                                        transactionsTab: EMutualFundOrderTabs.ALL_TRANSACTIONS,
                                    });
                                    // If API call and filter cleaning is required use the below code
                                    //   {
                                    //   transactionsTab: EMutualFundOrderTabs.ALL_TRANSACTIONS,
                                    //   callAPIAndCleanFilters: true,
                                    // } as IButtonCallbackRestArgs);
                                }
                            }, rightBtnSubmit: true }))) : null));
            case EMutualFundFlow.MANDATE:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(React.Fragment, null,
                    !isEmpty(mfData) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, schemeCode: schemeCode, showSwitchButton: false, setShow: setShowScheme, show: showScheme })),
                    React.createElement(SideBarClientDetails, __assign({}, props.clientDetails, { clientTier: (_7 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _7 === void 0 ? void 0 : _7.clientTier })),
                    React.createElement(DiffMandate, { show: true, setShow: hendleScreenState, mandateList: mandateList, selectedBank: selectedBank, selectedMandate: selectedMandate, setSelectedMandate: setSelectedMandate, setTOCFlow: setTOCFlow, getLinkedSipData: getLinkedSipData, linkedSipData: linkedSipData, setIsViewDetailsMode: setIsViewDetailsMode, selectedMandateId: selectedMandateId, setSelectedMandateId: setSelectedMandateId, temporaryViewMandateDetailsMandateId: temporaryViewMandateDetailsMandateId }),
                    React.createElement("div", { className: "bottom-contents mf-footer-contents" },
                        MandateError && (React.createElement("div", { className: "text-danger pdl-15 pb-10 DMSansNormal_12_400 pt-15" },
                            React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                            React.createElement("span", null, "Please create a mandate to proceed."))),
                        React.createElement(SideTxnFooter, { leftBtnText: "New Mandate", leftBtnOnClick: function () {
                                hendleScreenState(EMutualFundFlow.NEWMANDATE);
                            }, rightBtnText: "Select", rightBtnOnClick: handleRightBtnOnClickForFooter }))))));
            case EMutualFundFlow.NEWMANDATE:
                return (React.createElement(React.Fragment, null,
                    !isEmpty(mfData) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: mandateFlow !== EMandateFlow.INFOPAGE, setShow: setShowScheme, show: showScheme })),
                    React.createElement(SideBarClientDetails, __assign({}, props.clientDetails, { clientTier: (_8 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _8 === void 0 ? void 0 : _8.clientTier })),
                    React.createElement(CreateNewMandate, { show: true, hideDiffBank: (bankList === null || bankList === void 0 ? void 0 : bankList.length) > 1 ? false : true, setShow: hendleScreenState, selectedBank: selectedBank, setSelectedMandate: setSelectedMandate, selectedMandate: selectedMandate, bankList: bankList, setSelectedBank: setSelectedBank, setMandateFlow: setMandateFlow, mandateFlow: mandateFlow, clientDetails: props.clientDetails, clientAccType: props.clientDetails.accType, setMandateList: setMandateList, isPayNow: (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment) ===
                            firstInstallmentConstentEnum.NOW, setSelectedMandateId: setSelectedMandateId, isTriggeredFromOrderBook: props.isTriggeredFromOrderBook, hideMfTocSideBar: props.setShowTOC })));
            case EMutualFundFlow.VALIDATEMANDATE:
                return (React.createElement(CreateNewMandate, { defaultState: EMandateFlow.UPLOAD, show: true, setShow: hendleScreenState, selectedBank: selectedBank, setSelectedMandate: setSelectedMandate, selectedMandate: selectedMandate, bankList: bankList, setSelectedBank: setSelectedBank, setMandateFlow: setMandateFlow, mandateFlow: mandateFlow, clientDetails: props.clientDetails, clientAccType: props.clientDetails.accType, setMandateList: setMandateList, isPayNow: (purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment) ===
                        firstInstallmentConstentEnum.NOW, setSelectedMandateId: setSelectedMandateId }));
            case EMutualFundFlow.VALIDITY:
                return (React.createElement(React.Fragment, null,
                    React.createElement(CustomValidityData, { show: true, setShow: function () { return hendleScreenState(EMutualFundFlow.PURCHASE); }, purchaseFormData: purchaseFormData, setPurchaseFormData: setPurchaseFormData, minInstallments: 0 })));
            case EMutualFundFlow.IBREDIRECT:
                return React.createElement(ClosingComponent, { sideComponent: true });
            case EMutualFundFlow.IBPAGENOTE:
                return React.createElement(IBNotePage, null);
            case EMutualFundFlow.UPIAPPROVAL:
                return (React.createElement(PaymentUpi, { duration: 600, checkStatus: getOrderStatus, amount: (externalData === null || externalData === void 0 ? void 0 : externalData.isRetryPayment)
                        ? (_9 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _9 === void 0 ? void 0 : _9.amount
                        : purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount }));
            case EMutualFundFlow.PAYEMENTSTATUS:
                return (React.createElement(React.Fragment, null,
                    (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Order Confirmation" }) })),
                    React.createElement(PaymentStatus, { closeToc: (device === null || device === void 0 ? void 0 : device.isDesktop) ? props.setShowTOC : function () { }, 
                        //tocType={investmentType}
                        mfData: mfData, status: paymentstatusDetails.status, statusTitle: paymentstatusDetails.statusTitle, changeScreen: hendleScreenState, investmentType: investmentType, paymentstatusDetails: paymentstatusDetails.statusDetails, selectedMandate: selectedMandate, onClose: redirectFunction, isNfo: ifNfo ? true : false, serverError: serverError, fromOrderBook: undefined })));
            case EMutualFundFlow.VIEW_MANDATE_DETAIL:
                return (isViewDetailsMode && (React.createElement(MandateViewDetails, { linkedSipData: linkedSipData, setIsViewDetailsMode: setIsViewDetailsMode, setTOCFlow: setTOCFlow, clientDetails: props.clientDetails, mandateList: mandateList, selectedMandateId: selectedMandateId, temporaryViewMandateDetailsMandateId: temporaryViewMandateDetailsMandateId })));
            case EMutualFundFlow.STP:
            case EMutualFundFlow.SWITCH: {
                return (React.createElement(React.Fragment, null,
                    (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "mt-3" },
                        (props === null || props === void 0 ? void 0 : props.clientDetails) && (React.createElement(SideBarClientDetails, __assign({}, props === null || props === void 0 ? void 0 : props.clientDetails, { clientTier: (_10 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _10 === void 0 ? void 0 : _10.clientTier, tooltipPlacement: "bottom" }))),
                        React.createElement(SwitchAndSTPMain, { hendleScreenState: hendleScreenState, purchaseFormData: purchaseFormData, setPurchaseFormData: setPurchaseFormData, mfData: mfData, investmentType: investmentType, setShowTOC: props.setShowTOC, switchTransferFundOptions: switchTransferFundOptions, mfHoldingDetail: mfHoldingDetail, allmfData: allmfData, isSipCalendarOpen: isCalendarOpen, setIsSipCalendarOpen: setIsCalendarOpen, startDate: startDate, folio: selectedFolio, setFolio: setSelectedFolio, setPhysicalFlag: setPhysicalFlg, setFormErrors: setFormErrors, formErrors: formErrors, switchTransferFundsLoader: switchTransferFundsLoader, switchTransferFundsFilters: switchTransferFundsFilters, getMfSwitchDetailFunds: getMfSwitchDetailFunds, switchTransferFundsFilterLoader: switchTransferFundsFilterLoader, getMFSwitchToSchemeDetails: getMFSwitchToSchemeDetails, switchToSchemeValidationDetails: switchtoSchemeValidationDetails, toSchemeDetailsLoader: toSchemeDetailsLoader, switchTransferFundsError: switchTransferFundsError, isFundSelectedForSwitchTransfer: isFundSelectedForSwitchTransfer, setIsFundSelectedForSwitchTransfer: setIsFundSelectedForSwitchTransfer, selectedToScheme: selectedToScheme, setSelectedToScheme: setSelectedToScheme }))),
                    " "));
            }
            case EMutualFundFlow.CONFIRM_ORDER: {
                var handleProceedForConfirm = function () {
                    if (props.isModify) {
                        onSubmitModify();
                    }
                    else
                        onSubmit();
                };
                var handleEditBackBtn = function () {
                    hendleScreenState(previousScreenState);
                    if (previousScreenState === EMutualFundFlow.SWITCH ||
                        previousScreenState === EMutualFundFlow.STP) {
                        setIsFundSelectedForSwitchTransfer(true);
                    }
                };
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "".concat(![EMutualFundFlow.STP, EMutualFundFlow.SWITCH].includes(previousScreenState)
                            ? "mt-3"
                            : "", " d-flex flex-column height-100") },
                        !isEmpty(mfData) &&
                            [EMutualFundFlow.STP, EMutualFundFlow.SWITCH].includes(previousScreenState) && (React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, HandleResetMfData: resetMfData, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, showReturnOption: false, showSwitchButton: false })),
                        (props === null || props === void 0 ? void 0 : props.clientDetails) && (React.createElement(SideBarClientDetails, __assign({}, props === null || props === void 0 ? void 0 : props.clientDetails, { clientTier: (_11 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _11 === void 0 ? void 0 : _11.clientTier }))),
                        React.createElement(TxnConfirmationScreen, { backBtnOnClick: handleEditBackBtn, purchaseFormData: purchaseFormData, txnType: props.isModify ? "Modified" : investmentType, onEdit: handleEditBackBtn, orderStatus: orderStatus, isModify: props.isModify }),
                        React.createElement("div", { className: "bottom-contents mf-footer-contents" },
                            React.createElement(SideTxnFooter, { leftBtnText: "Cancel", leftBtnOnClick: handleEditBackBtn, rightBtnText: "Confirm", rightBtnOnClick: handleProceedForConfirm })))));
            }
            case EMutualFundFlow.CANCEL:
                return (React.createElement("div", { className: "d-flex flex-column height-100" },
                    React.createElement(MFTocHeader, { name: (_13 = (_12 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _12 === void 0 ? void 0 : _12.scheme) === null || _13 === void 0 ? void 0 : _13.schemeName, subText1: (_15 = (_14 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _14 === void 0 ? void 0 : _14.scheme) === null || _15 === void 0 ? void 0 : _15.catName, subText2: (_17 = (_16 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _16 === void 0 ? void 0 : _16.scheme) === null || _17 === void 0 ? void 0 : _17.subCatName, schemeType: (_19 = (_18 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _18 === void 0 ? void 0 : _18.scheme) === null || _19 === void 0 ? void 0 : _19.schPlan, maxWidth: 400, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: false, purchaseAllowed: false, isModify: true, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: false, setShow: setShowScheme, show: showScheme }),
                    (props === null || props === void 0 ? void 0 : props.clientDetails) && (React.createElement(SideBarClientDetails, __assign({}, props === null || props === void 0 ? void 0 : props.clientDetails, { clientTier: (_20 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _20 === void 0 ? void 0 : _20.clientTier }))),
                    React.createElement(CancelOrder, { investmentType: (_21 = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _21 === void 0 ? void 0 : _21.displayTransactionType }),
                    React.createElement(SideTxnFooter, { leftBtnText: "Yes, Cancel", leftBtnOnClick: cancelSip, rightBtnText: "No, Go Back", rightBtnOnClick: hideTOCSideBar, isDisableButton: purchaseApplyBtnDisabled })));
            case EMutualFundFlow.PAUSE:
                return (React.createElement("div", { className: "d-flex flex-column height-100" },
                    React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, setShow: setShowScheme, show: showScheme, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: false }),
                    (props === null || props === void 0 ? void 0 : props.clientDetails) && (React.createElement(SideBarClientDetails, __assign({}, props === null || props === void 0 ? void 0 : props.clientDetails, { clientTier: (_22 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _22 === void 0 ? void 0 : _22.clientTier }))),
                    React.createElement(PauseOrder, { lastDate: moment((_23 = props === null || props === void 0 ? void 0 : props.mfmodifyData) === null || _23 === void 0 ? void 0 : _23.nextInstallmentDate)
                            .add(Number((_26 = (_24 = mfData === null || mfData === void 0 ? void 0 : mfData.sipData) === null || _24 === void 0 ? void 0 : _24[(_25 = props.mfmodifyData) === null || _25 === void 0 ? void 0 : _25.frequency]) === null || _26 === void 0 ? void 0 : _26.pauseMaxInst), (((_28 = (_27 = props.mfmodifyData) === null || _27 === void 0 ? void 0 : _27.frequency) === null || _28 === void 0 ? void 0 : _28.toLowerCase()) +
                            "s"))
                            .format("D MMMM YYYY"), minInstallmentPause: Number((_31 = (_29 = mfData === null || mfData === void 0 ? void 0 : mfData.sipData) === null || _29 === void 0 ? void 0 : _29[(_30 = props.mfmodifyData) === null || _30 === void 0 ? void 0 : _30.frequency]) === null || _31 === void 0 ? void 0 : _31.pauseMaxInst) }),
                    React.createElement(SideTxnFooter, { leftBtnText: "Pause for ".concat((_34 = (_32 = mfData === null || mfData === void 0 ? void 0 : mfData.sipData) === null || _32 === void 0 ? void 0 : _32[(_33 = props.mfmodifyData) === null || _33 === void 0 ? void 0 : _33.frequency]) === null || _34 === void 0 ? void 0 : _34.pauseMaxInst, " installment"), leftBtnOnClick: pauseSIP, rightBtnText: "Continue SIP", rightBtnOnClick: hideTOCSideBar, isDisableButton: purchaseApplyBtnDisabled })));
            case EMutualFundFlow.RESUME:
                return (React.createElement("div", { className: "d-flex flex-column height-100" },
                    React.createElement(MFTocHeader, { schemeList: parentMfData === null || parentMfData === void 0 ? void 0 : parentMfData.schemePlanListing, name: mfData === null || mfData === void 0 ? void 0 : mfData.schemeName, subText1: mfData === null || mfData === void 0 ? void 0 : mfData.catName, subText2: mfData === null || mfData === void 0 ? void 0 : mfData.subCatName, schemeType: schemeType, maxWidth: 400, returnType: mfData === null || mfData === void 0 ? void 0 : mfData.returnType, ascSchemes: allmfData === null || allmfData === void 0 ? void 0 : allmfData.returnOption, setSchemeCode: changeScheme, divFrq: allmfData === null || allmfData === void 0 ? void 0 : allmfData.divFrequency, investmentType: investmentType, setInvestmentType: setInvestmentType, sipFlag: mfData === null || mfData === void 0 ? void 0 : mfData.sipFlag, purchaseAllowed: mfData === null || mfData === void 0 ? void 0 : mfData.lumpsumFlag, isModify: externalData.isModify
                            ? externalData.isModify
                            : ifNfo === "nfo"
                                ? true
                                : false, setShow: setShowScheme, show: showScheme, schemeCode: schemeCode, showSwitchButton: false, showReturnOption: false }),
                    (props === null || props === void 0 ? void 0 : props.clientDetails) && (React.createElement(SideBarClientDetails, __assign({}, props === null || props === void 0 ? void 0 : props.clientDetails, { clientTier: (_35 = props === null || props === void 0 ? void 0 : props.clientDetails) === null || _35 === void 0 ? void 0 : _35.clientTier }))),
                    React.createElement(ResumeOrder, null),
                    React.createElement(SideTxnFooter, { leftBtnText: "Not Now", leftBtnOnClick: hideTOCSideBar, rightBtnText: "Resume SIP", rightBtnOnClick: resumeSIP, isDisableButton: purchaseApplyBtnDisabled })));
        }
    };
    return (React.createElement("div", { className: "mf-transaction-container d-flex flex-column" }, TOCFlow()));
};
export default MutualFund;
